 'use strict';

import { forEach } from "lodash-es";
import util from "./util";

var unbind = 0;
var unbindReg = 0;
var unbindcarousel = 0;
var unBindBestSeller = 0;
let unbindCompare = 0;
let unbindRecomm = 0;
var old_visible;
var currencyCode = window.User.currencyCode;

function isMobile() {
	return $(window).width() <= 640;
}
//Specific for PDP
function getProductName()	{
	return $(".product-title .product-name").text();
}
//Specific for PDP
function getProductBrand() {
	return "NARS EMEA"; //$(".product-detail .product-brand").text();
}
//Specific for PDP
function getProductID()	{
	return $("#pid").val();
}
//Specific for PDP
function getProductCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(1)").text().trim();
}
//Specific for PDP
function getProductsubCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(2)").text().trim();
}
// Specific for PDP
function getProductsubsubCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(3)").text().trim();
}
// Specific for PDP
function getProductOrederType() {
	var replen = $(".replenishmentCycle").val();
	if(replen>0){
		return "Replenishment"
	} else {
		return "Regular"
	}
	 
}

function listType(){ // Search Results or Product Category List
    return searchItems.search ? 'search result list' : 'product category list';
}

function listName(){ // Search Results or Product Category List
    return searchItems.search ? 'Search' : $(".breadcrumb").find(".breadcrumb-element:last").text().trim();
}

function getActiveSortingRule() {
	var httpParams = util.getQueryStringParams(window.location.href);
	var sortParam = httpParams["srule"];

	if (!sortParam) {
		return null;
	}

	return sortParam.split("-").map(function (w) {
		return w[0].toUpperCase() + w.substr(1);
	}).join(" ");
}

function pushToDataLayer(o) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(util.filterObj(o));
}

function isScrolledIntoView(elem)
{
	var docViewTop = $(window).scrollTop();
	var docViewBottom = docViewTop + $(window).height() - 150;
	var elemTop = $(elem).offset().top;
	return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
}

function isElementInViewport (el) {

    var top_of_element = el.offset().top;
    var bottom_of_element = el.offset().top + el.outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();
    var menuHeight = $('.sticky-header').outerHeight() || 0;
    var pdpMobileSticky =  isMobile() && $('.product-add-to-cart').length ? $('.product-add-to-cart').outerHeight() || 0 : 0;

    top_of_element = top_of_element - menuHeight;
    bottom_of_element = bottom_of_element + pdpMobileSticky;

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
    	return true;
    } else {
    	return false;
    }
}

function isElementChanged(el) {
    var visible = isElementInViewport(el);
    if (visible != old_visible) {
    	old_visible = visible;
        return 0;
    } else {
    	return 1;
    }
}

/*
 * datalayer for minicart panel 
 */
function cartModalOpen() {
	pushToDataLayer({
		"event": "cartModalOpen"
	});
}

function cartModalClose() {
	pushToDataLayer({
		"event": "cartModalClose"
	});
}

function minicartProductList() {
	//eeListView dataLayer for minicart open
		var productsList = [];
		var count = 1;
		for(var i = 0; i < miniCartConfirmation.productLineItems.length; i++) {

			if(miniCartConfirmation.productLineItems.length) { 
				var productListData = {
					"name" : miniCartConfirmation.productLineItems[i].name,
					"id" : miniCartConfirmation.productLineItems[i].id,
					"price" : miniCartConfirmation.productLineItems[i].price,
					"brand" : getProductBrand(),
					"category" : miniCartConfirmation.productLineItems[i].category,
					"subCategory" : miniCartConfirmation.productLineItems[i].subCategory,
					"subSubCategory": miniCartConfirmation.productLineItems[i].subSubCategory,
					"listType" : "Mini Cart",
					"listName" : "Articles in cart",
					"position" : count++,
					"productAutoReplen" : miniCartConfirmation.productLineItems[i].productautoreplenish,
					"productOutOfStock" : miniCartConfirmation.productLineItems[i].productOutOfStock,
					"productNumReviews" : miniCartConfirmation.productLineItems[i].productNumReviews,
					"productStarRating" : miniCartConfirmation.productLineItems[i].productStarRating,
					"productColor" : miniCartConfirmation.productLineItems.productColor,
					"productType" : miniCartConfirmation.productLineItems[i].productType,
					"productVariantID" : miniCartConfirmation.productLineItems[i].productVariantID,
					"productBundle" : miniCartConfirmation.productLineItems[i].productBundle,
				}
				
				productsList.push(productListData)
			}
		}
		pushToDataLayer({
			"currencyCode": currencyCode,
			"event": "eeListView",
			"eeAction": "eeListView",
			"pageCategory": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			'products': productsList
		});
}

//page-specific: PLP
function getRefinementsFromURL() {
	var str = "";
	if(window.location.href.split("?").length > 1){
		var urlparam;
		if(window.location.href.split("?")[1].indexOf("&")>-1){
			urlparam = window.location.href.split("?")[1].split("&");
			var length = urlparam.length;
			var prefnval,prefnkey,prefvval,prefvkey;
			for(var i =0;i<length;i++){
				var prefn = urlparam[i].indexOf("prefn");
				if(prefn > -1){
				  prefnkey = urlparam[i].split("=")[0];
				  prefnval = urlparam[i].split("=")[1];
				  console.log(prefnkey);
				  var num = prefnkey.charAt(5);
				  for(var a =0;a<length;a++){
					var prefv = urlparam[a].indexOf("prefv");
					prefvkey = urlparam[a].split("=")[0];
					if(prefvkey == "prefv"+num){
					   prefvval = urlparam[a].split("=")[1];
					   str += "[" + prefnval  + ":" + prefvval  + "]";
					}	
				  }
				} 
			}
		}
	}
	return str;
}

function trackConsultationEvent(data) {
	var TOOL_TYPES = {
		"skincareConsultation": "Skincare Consultation"
	};

	pushToDataLayer({
		"event": "consultation" + data.element[0].toUpperCase() + data.element.substr(1),
		"pageCategory": "Consultation Tool",
		"consultationToolType": TOOL_TYPES[data.toolname] || data.toolname,
		"consultationQuestion": data.question,
		"consultationResponse": data.answers[0]
	});
}

function trackConsultationPageview(data) {
	pushToDataLayer({
		"event": "consultationSteps",
		"pageCategory": "Consultation Tool",
		"consultationToolType": data.toolname,
		"consultationStep": data.pagename
	});
}

function trackInternalPromotionEvent(data) {
	
	var promotionURL = data.pageName;
	
	pushToDataLayer({
		"event": "eePromoClick",
		"nextPage": promotionURL,
		"pageSubCategory": (pageInfo.pageCategory=='My Account' || pageInfo.pageCategory=='Checkout Page') ? pageInfo.pageSubCategory : '',
		"pageCategory": pageInfo.pageCategory,
		'promotion': {
		"position": data.position,
		"id": data.id,
		"creative": data.creative,
		"name": data.name
		}
	}), (function(){setTimeout(function(){
		if (promotionURL != undefined) {
			document.location = promotionURL;
		}
		}, 1000);
	})();
}

function trackInternalPromotionPageView(data) {
	pushToDataLayer({
		"eeAction": "eePromoView",
		"event" : "eePromoView",
		"pageSubCategory": pageInfo.pageSubCategory,
		"pageCategory": pageInfo.pageCategory,
		'promotions': [{
		"position": data.position,
		"id": data.id,
		"creative": data.creative,
		"name": data.name
		}]
	});
}

function getReturnedProducts() {
	var products = [];
	var i = Number(0);
	$('.return-qty').each(function() {
		if($(this).val() > 0) {
			window.returnedProducts[i].quantity = $(this).val();
			products.push(window.returnedProducts[i]);
		}
		i++;
	});
	
	return products;
}

function getPageName() {
	if ($(".homepage-container").length) {
		return "Home Page";
	} else if ($(".pt_product-search-noresult").length) {
		return "Site Search";
	} else if ($(".pt_cart").length) {
		return "Cart Page";
	}
	else if ($(".pt_product-details").length) {
		return "Product Page";
	}
}

// reassurance data layer new
function reassuranceCheckoutDatalayer(data, clickedIndex) {
	let reassuranceType, reassurancePage;
	reassuranceType = $(data).find('.reassurance-content').text().trim();
	reassurancePage = "PDP";
	pushToDataLayer({
		'event': 'reinsurance_interaction',
		'reinsurance_type' : reassuranceType,
		'reinsurance_page' : reassurancePage,
		'reinsurance_position': clickedIndex + 1
	});

	if($("#reinsurance-panel").length) {
		$("#reinsurance-panel .panel-body .panel-content-buttons").attr({
			"data-reinsurance-type": reassuranceType,
			"data-reinsurance-page": reassurancePage,
			"data-reinsurance-position": clickedIndex + 1
		})
	}
}

function initializeGlobalEvents() {
	var navctr = true;
	var gtmNavData = "";
	
	//var arr = []; // Array to hold the keys
	// Iterate over localStorage and insert the keys that meet the condition into arr	
	for (var i = sessionStorage.length-1; i >=0; i--){
	    if (sessionStorage.key(i).substring(0,9) == 'gtmpromo-') {
	    	sessionStorage.removeItem(sessionStorage.key(i));
	    }
	}
	/*commenting out this code and moidifying above code to not create second loop
	// Iterate over arr and remove the items by key
	for (var i = 0; i < arr.length; i++) {
		sessionStorage.removeItem(arr[i]);
	}
	*/
	
	$(document)

		//reinsurance-content-checkout-datalayer-push
		.on('click', '.reinsurance-wrapper-cart', function () {
			var reinsuranceType, clickedIndex, reinsurancePage;
			reinsuranceType = $(this).find('.reinsurance-title').html();
			clickedIndex = $(this).parents(".content-asset").index();
			if (pageInfo.pageSubCategory === 'Cart Page') {
				reinsurancePage = 'Cart Page'
			} else if (pageInfo.pageSubCategory === 'Shipping' || window.Resources.PAGE_CATEGORY == 'coshipping-start') {
				reinsurancePage = 'Shipping'
			} else if (pageInfo.pageSubCategory === 'Payment' || window.Resources.PAGE_CATEGORY == 'coshipping-singleshipping') {
				reinsurancePage = 'Payment'
			}

			if ($(this).hasClass('show-description') === false || $(this).hasClass('open-reinsurance-panel')) {
				pushToDataLayer({
					'event': 'reinsurance_interaction',
					'reinsurance_type' : reinsuranceType,
					'reinsurance_page' : reinsurancePage,
					'reinsurance_position': clickedIndex + 1
				});
			}

			if($("#reinsurance-panel").length) {
				$("#reinsurance-panel .panel-body .panel-content-buttons").attr({
					"data-reinsurance-type": reinsuranceType,
					"data-reinsurance-page": reinsurancePage,
					"data-reinsurance-position": clickedIndex + 1
				})
			}
		})

		//reinsurance-content-datalayer-push
		.on('click', '.reinsurance-wrapper', function () {
			var reinsuranceType, clickedIndex, reinsurancePage;
			reinsuranceType = $(this).find('.reinsurance-title').html();
			clickedIndex = $(".reinsurance-wrapper").index(this);
			reinsurancePage = "PDP";
			if (!$(this).find('.reinsuranceDesc').hasClass('open')  || $(this).hasClass('open-reinsurance-panel')) {
				pushToDataLayer({
					'event': 'reinsurance_interaction',
					'reinsurance_type' : reinsuranceType,
					'reinsurance_page' : reinsurancePage,
					'reinsurance_position': clickedIndex + 1
				});
			}
			if($("#reinsurance-panel").length) {
				$("#reinsurance-panel .panel-body .panel-content-buttons").attr({
					"data-reinsurance-type": reinsuranceType,
					"data-reinsurance-page": reinsurancePage,
					"data-reinsurance-position": clickedIndex + 1
				})
			}
		})

		//reinsurance content helpful datalayer push
		.on('click', '.panel-content-buttons .panel-bottom-yes, .panel-content-buttons .panel-bottom-no', function () {
			var reinsuranceType = $(this).parent().attr("data-reinsurance-type");
			var reinsurancePage = $(this).parent().attr("data-reinsurance-page");
			var clickedIndex = $(this).parent().attr("data-reinsurance-position");
			pushToDataLayer({
				'event': 'reinsurance_interaction',
				'reinsurance_type' : reinsuranceType,
				'reinsurance_page' : reinsurancePage,
				'reinsurance_position': clickedIndex,
				'reinsurance_helpful': $(this).text().trim().toLowerCase()
			});
		})

		.on('click', '.sample-old-checkout #selectsample , .sample-select-tile, .cart_page .sample-header', function () {
			var _this = $(this);

			pushToDataLayer({
				'event' : 'select_sample',
				'checkoutStep' :'1',
				'pageCategory': pageInfo.pageCategory,
				'pageSubCategory': pageInfo.pageSubCategory,
				'currencyCode':  window.Resources.CURRENCY,
				'collectionName': basketConfirmation.productLineItems[0].brand
			});
			
		})

		.on('click', '.sample-old-wrapper .button.multiselect, .sample-product-tile-wrapper', function () {
			var _this = $(this);
			var prodName;
			var $gtmProductTile;
			if ($(this).attr('value') == 'selectable' || $(this).attr('value') == 'selectproduct' || !$(this).hasClass(' product-tile-selected')) {
				if (window.Resources.PAGE_CATEGORY == 'cart-show') {
						$gtmProductTile = _this.closest('.product-tile-wrapper').find('.gtm-product-tile');
				} else {
					$gtmProductTile = _this.parents(".product-tile-wrapper").find('.gtm-product-tile');
				}
				var tileVariantData = $gtmProductTile.data('value');
				
				pushToDataLayer({
					'event' : 'add_sample',
					'sample_name' : tileVariantData.name,
					'sample_brand' : tileVariantData.brand,
					'checkoutStep' : '1',
					'pageCategory': pageInfo.pageCategory,
					'pageSubCategory': pageInfo.pageSubCategory,
					'currencyCode': window.Resources.CURRENCY,
					'collectionName': tileVariantData.customBrand,
				});	
			}
		})

		.on('click', '.crosssell-recommendation-modal.active .recommendation-item #cs-add-to-cart-1', function (e) { 
			e.stopPropagation();
			addToCartGymShark($(this).closest('.recommendation-item'));			
		})	

		.on('click', '#samples-add-to-cart_page','#samples-add-to-cart', function () {
			var _this = $(this);
			var sample_added_name = [];
			var addedSamples = $(document).find('.sample-overlay button[value="selected"]').closest('.product-tile-wrapper');
			var sample_brand;
			var collectionName;
			addedSamples.each(function () {
				var product = {};
				var gtmValue = $(this).find('.gtm-product-tile');
				var tileVariantData = gtmValue.data('value');
				product.name = tileVariantData.name;
				sample_brand = tileVariantData.brand;
				collectionName = tileVariantData.customBrand;
				sample_added_name.push(product);
			});
			var concatenatedString = '';

			for (var i = 0; i < sample_added_name.length; i++) {
				if (sample_added_name[i].name) { // Check if the 'name' property exists
					if (i > 0 && concatenatedString !== '') {
						concatenatedString += ', ';
					}
					concatenatedString += sample_added_name[i].name;
				}
			}
			var sample_name = concatenatedString.trim();
			var sample_number = $(document).find('.sample-overlay button[value="selected"]').length;
			
			pushToDataLayer({
				'event' : 'add_sample_to_cart', 
				'sample_number' : sample_number,
				'sample_name_listing': sample_name,
				'checkoutStep' : '1',
				'pageCategory': pageInfo.pageCategory,
				'pageSubCategory': pageInfo.pageSubCategory,
				'currencyCode': window.Resources.CURRENCY,
				'collectionName': collectionName,
			});
		})

		
		//saving current page category and subcategory to use on storelocator page load
		.on('click', ".store-locator-form .button", function(e) {
			localStorage.setItem('storelocatorpagecat', pageInfo.pageCategory);
			localStorage.setItem('storelocatorpagesubcat',pageInfo.pageSubCategory); 
		})
	
		// promo hover event
		.on('click mouseover touchstart', ".top-banner .level-1 .has-sub-menu >a", function (e) {
			var $ga_offers = $(this).parent().find('.level-2-link.active').find('.ga-offers');
			if($ga_offers.length > 0){
				if (sessionStorage.getItem('gtmpromo-'+$ga_offers.attr("ga-offers-promo-id")+"-"+$ga_offers.attr("ga-offers-promo-position")) !="triggered"){
					pushToDataLayer({
						"eeAction": "eePromoView",
						"event" : "eePromoView",
						"pageSubCategory": pageInfo.pageSubCategory,
						"pageCategory": pageInfo.pageCategory,
						'promotion': {
						"position": $ga_offers.attr("ga-offers-promo-position"),
						"id": $ga_offers.attr("ga-offers-promo-id"),
						"creative": $ga_offers.attr("ga-offers-promo-creative"),
						"name": $ga_offers.attr("ga-offers-promo-name")
						}
					});
					//set session storage element so that its triggered only once
					sessionStorage.setItem('gtmpromo-'+$ga_offers.attr("ga-offers-promo-id")+"-"+$ga_offers.attr("ga-offers-promo-position"),"triggered");
				}
			}
		})
		
		.on('click mouseover touchstart', ".top-banner .level-2-link", function (e) {
			var $ga_offers = $(this).find('.ga-offers');
			if($ga_offers.length > 0){
				if (sessionStorage.getItem('gtmpromo-'+$ga_offers.attr("ga-offers-promo-id")+"-"+$ga_offers.attr("ga-offers-promo-position")) !="triggered"){
					pushToDataLayer({
						"eeAction": "eePromoView",
						"event" : "eePromoView",
						"pageSubCategory": pageInfo.pageSubCategory,
						"pageCategory": pageInfo.pageCategory,
						'promotion': {
						"position": $ga_offers.attr("ga-offers-promo-position"),
						"id": $ga_offers.attr("ga-offers-promo-id"),
						"creative": $ga_offers.attr("ga-offers-promo-creative"),
						"name": $ga_offers.attr("ga-offers-promo-name")
						}
					});
					//set session storage element so that its triggered only once
					sessionStorage.setItem('gtmpromo-'+$ga_offers.attr("ga-offers-promo-id")+"-"+$ga_offers.attr("ga-offers-promo-position"),"triggered");
				}
			}
		})

		
		// add to wishlist in pdp and quickview
		.on('click', "#save-for-later", function (e) {
				pushToDataLayer({
					"event": "clickSaveForLater",
					"productCategory": getProductCategory(),
					"productSubCategory": getProductsubCategory(),
					"productName": getProductName(),
					"pageCategory": pageInfo.pageCategory,
					"pageSubCategory": (pageInfo.pageCategory=='My Account' || pageInfo.pageCategory=='Checkout Page') ? pageInfo.pageSubCategory : '',
					"id": $(this).data("masterid"),
					"productVariantID": $(this).data("masterid")==getProductID()? "" : getProductID()
					});
		})

		// add to wishlist in cart
		.on('click', ".add-to-wishlist",function (e) {
			var index = $(this).parents(".cart-row").index();
			pushToDataLayer({
				"event": "clickSaveForLater",
				"productCategory":basketConfirmation.productLineItems[index-2].category,
				"productSubCategory":basketConfirmation.productLineItems[index-2].subCategory,
				"productName":basketConfirmation.productLineItems[index-2].name,
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": (pageInfo.pageCategory=='My Account' || pageInfo.pageCategory=='Checkout Page') ? pageInfo.pageSubCategory : '',
				"id": basketConfirmation.productLineItems[index-2].id,
				"productVariantID": basketConfirmation.productLineItems[index-2].productVariantID,
			});
		})
		
		// remove to wishlist PDP
		.on('click', ".remove-from-wishlist", function(e) {
			pushToDataLayer({
				"event": "removeFromWishlist",
				"productCategory":getProductCategory(),
				"productSubCategory": getProductsubCategory(),
				"productName": getProductName(),
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				"id": getProductID(),
				"productVariantID": $(this).data("masterid")
				});
		})

		// remove to wishlist from my account
		.on('click', ".wishlist-item .delete-item", function(e) {
			var data =  $(this).data("catid");
			var productCategory = data[data.length-2];
			var productSubCategory = data[data.length-3];
			pushToDataLayer({
				"event": "removeFromWishlist",
				"productCategory":productCategory,
				"productSubCategory": productSubCategory,
				"pageSubCategory": "Save for Later",
				"productName": $(this).data("productname"),
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				"id": $(this).data('prodid'),
				"productVariantID": $(this).data('variantid')
				});
		})

		// remove to wishlist Quickview
		.on('click', "#modal-content .remove-from-wishlist", function(e) {
			pushToDataLayer({
				"event": "removeFromWishlist",
				"productCategory":getProductCategory(),
				"productSubCategory": getProductsubCategory(),
				"productName": getProductName(),
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				"id": getProductID(),
				"productVariantID": $(this).data('variantid')
				});
		})

		// newsletter in navigation;
		.on("clicknewsletter", function (e, data) {
				 pushToDataLayer({
					"event": "newsletterSubscription",
					"siteLocation": data.siteloc,
					"pageSubCategory": pageInfo.pageCategory == "My Account" ? getProductsubCategory():"",
					"pageCategory": pageInfo.pageCategory
					});
		 })


		// click ask question in pdp
		.on("click",".bv-ask-question",	function (e) {
			pushToDataLayer({
				page:pageInfo.pageCategory,
				"event": "askQuestion",
				productCategory:getProductCategory(),
				pageSubCategory: pageInfo.pageSubCategory,
				productName:getProductName(),
				pageCategory: pageInfo.pageCategory
			});
		})
		
		//click create return button
		.on("click", "#dwfrm_return .create-return-submit", function (e){
			var $ga_orderreturn = $('#dwfrm_return');
			var productsData = getReturnedProducts();
			pushToDataLayer({
				page:pageInfo.pageCategory,
				"event": "eeRefund",
				"pageCategory":pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				"transactionId": $ga_orderreturn.find('.return-order-no').val(),
				"products": productsData
			});
		}).on('click', '.regimenzone .product-tile  a.thumb-link', function (e) {
			//skip for button/select click
			if(!$(e.target).hasClass("variation-select") && !$(e.target).hasClass("basket-icon")){			
			var $gtmProductTile = $(this).parents(".product-tile").find('.gtm-product-tile');
			var tileVariantData = $gtmProductTile.data('value');
			var position = $(".regimenzone .product-tile a.product-tile-wrapper").index($(this)) + 1;
			pushToDataLayer({
					"event": "eeListClick",
					"pageCategory": pageInfo.pageCategory,
					'products': [{
						"listType": "Regimen",
						"listName": pageInfo.pageCategory,
						"list": pageInfo.pageCategory,
						"position" : position,
						"id": tileVariantData.masterID,
						"productVariantID": tileVariantData.master ? tileVariantData.defalutvariant : tileVariantData.ID,
						"category": tileVariantData.catid,
						"price": tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice,
						"name": tileVariantData.name,
						"brand": tileVariantData.brand,
						"quantity": $(this).parents(".product-tile").find('.quantity select').val(),
						"size": tileVariantData.size,
						"subCategory": tileVariantData.subcategory,
						"subSubCategory": tileVariantData.subsubcategory,
						"productAutoReplen": tileVariantData.productautoreplenish,
						"productOutOfStock": tileVariantData.productOutOfStock,
						"productColor": tileVariantData.productColor,
						"productType": "Product",
						"collectionName": tileVariantData.customBrand,
						"productNumReviews": tileVariantData.productNumReviews,
						"productOrderType": getProductOrederType(),
						"productStarRating": tileVariantData.productStarRating
					}]
				});
			}
		})
		// Scroll on reviews in pdp
		.scroll(function() {			
			if (($(".regimenzone").find(".regimen-container").length) > 0) {
				if (isScrolledIntoView(".regimen-container") && unbindReg < 1) {
					unbindReg = 1;
					var $regimenbg =  $(".regimenzone").find(".regimen-container");
					var productsList = [];
					var count = 1;
					$regimenbg.find('.gtm-product-tile').each(function () {
						var product = {};
						
						var tileVariantData = $(this).data('value');
						product.listType = "Regimen";
						product.listName = pageInfo.pageCategory;
						product.list = pageInfo.pageCategory;
						product.position = count++;
						product.ID = tileVariantData.masterID || tileVariantData.ID;
						product.productVariantID = tileVariantData.ID;
						product.category = tileVariantData.catid;
						product.price = tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice;
						product.name = tileVariantData.name;
						product.brand = tileVariantData.brand;
						product.quantity = productCache.productSet ? $("#quantity").val() : tileVariantData.quantity;
						product.size = tileVariantData.size;
						product.subCategory = tileVariantData.subcategory;
						product.subSubCategory = tileVariantData.subsubcategory;
						product.productAutoReplen = tileVariantData.productautoreplenish;
						product.productOutOfStock = tileVariantData.productOutOfStock;
						product.productColor = tileVariantData.productColor;
						product.productType = "Product";
						product.collectionName = tileVariantData.customBrand;
						product.productNumReviews = tileVariantData.productNumReviews;
						product.productStarRating = tileVariantData.productStarRating;
						product.productOrderType = getProductOrederType();
						productsList.push(product);
					});
					
					pushToDataLayer({
						"currencyCode": window.User.currencyCode,
						"eeAction": "eeListView",
						"event": "eeListView",
						"pageCategory": pageInfo.pageCategory,
						"products": productsList
					});
				}
			}
			
			if ($(".rating-review-container").length) {
				if (isScrolledIntoView(".rating-review-container") && unbind < 1) {
					unbind = 1;
					pushToDataLayer({
							event: "productReviewsView",
							page: window.location.pathname,
							productCategory: getProductCategory(),
							productName:getProductName(),
							pageCategory: "Product Page",
							pageSubCategory: pageInfo.pageSubCategory
					});
				}
			}
			 
			 // for recommendation in pdp and cart, Best Seller and Recently Viewed in Homepage
			if ($("#recommendation-slick-carousel .carousel-recommendations").length > 0  || $(".cross-sell #recommendation-slick-carousel .carousel-recommendations").length > 0 ) {
				var carousel = $("#recommendation-slick-carousel .carousel-recommendations"),
				unBindBestSeller = isElementChanged(carousel);	
				if (isElementInViewport(carousel) &&  unBindBestSeller < 1) {
					var tempProd = [];
					var tempInd = 0;
					$('#recommendation-slick-carousel ul.carousel-recommendations li.recommendation-item').each(function(i){					    	
						if($(this).attr('aria-hidden') == "false"){		
							tempInd = $(this).attr('data-slick-index');
							prodData.product[tempInd].price = parseFloat($(this).find(".product-pricing").find(".price-sales").attr("content"));
							tempProd.push({
								"name": prodData.product[tempInd].name,
								"id": prodData.product[tempInd].id,
								"price": prodData.product[tempInd].price,
								"brand": getProductBrand(),
								"category": prodData.product[tempInd].category,
								"listType" : "Einstein",
								"list": `${"Einstein"} > ${getPageName()}`,
								"listName": getPageName(),
								"position": prodData.product[tempInd].position,
								"productAutoReplen": prodData.product[tempInd].productAutoReplen,
								"productOutOfStock": prodData.product[tempInd].productOutOfStock,
								"productNumReviews": prodData.product[tempInd].prodNumReviews,
								"productStarRating": prodData.product[tempInd].prodStarRating,
								"productColor": prodData.product[tempInd].color,
								"productType": prodData.product[tempInd].productType,
								"productVariantID": prodData.product[tempInd].productVariantID,
								"quantity": prodData.product[tempInd].quantity,
								"size": prodData.product[tempInd].size,
								"subCategory" : prodData.product[tempInd].subCategory,
								"subSubCategory" : prodData.product[tempInd].subSubCategory,
							});
						}
								  
					});
						
					if (tempProd.length > 0) {
						unBindBestSeller =  1;
						pushToDataLayer({
							"event" : "eeListView",
							"eeAction": "eeListView",
							"currencyCode": window.User.currencyCode,								
							"pageCategory": pageInfo.pageCategory,
							"products": tempProd });
					} else {
						old_visible = null;
					} 
				} else {
					 unbindcarousel = 0;
				}
			}
			
			// for product compare section
			if ($("#product-compare").length > 0) {

				const result = isScrolledIntoView("#product-compare");
				if (result && unbindCompare < 1) {
					unbindCompare = 1;

					const $compareItems = $('.product-compare-item');
					const tileVariantDataArr = window.compareProdData.product;
					const productsList = [];
					let count = 1;

					//2 for mobile, 4 for desktop
					let maxItems = $(window).width() <= 768 ? 2 : 4;

					if (Array.isArray(tileVariantDataArr)) {

						$compareItems.each(function (i) {
							if (i >= maxItems) return false; // break after maxItems
							if (tileVariantDataArr[i]) {
								const tileVariantData = tileVariantDataArr[i];
								const productdetails = {};
								productdetails.listType = "Product Compare";
								productdetails.listName = "Product Page";
								productdetails.position = count++;
								productdetails.brand = tileVariantData.brand;
								productdetails.category = tileVariantData.category;
								productdetails.categoryID = tileVariantData.categoryID;
								productdetails.collectionName = tileVariantData.collectionName;
								productdetails.color = tileVariantData.color;
								productdetails.id = tileVariantData.id;
								productdetails.name = tileVariantData.name;
								productdetails.price = tileVariantData.price;
								productdetails.productColor = tileVariantData.productColor;
								productdetails.productNumReviews = tileVariantData.productNumReviews;
								productdetails.productOutOfStock = tileVariantData.productOutOfStock;
								productdetails.productStarRating = tileVariantData.productStarRating;
								productdetails.productType = tileVariantData.productType;
								productdetails.productVariantID = tileVariantData.productVariantID;
								productdetails.size = tileVariantData.size;
								productdetails.subCategory = tileVariantData.subCategory;
								productdetails.subCategoryID = tileVariantData.subCategoryID;
								productdetails.subSubCategory = tileVariantData.subSubCategory;
								productdetails.subSubCategoryID = tileVariantData.subSubCategoryID;
								productdetails.variant = tileVariantData.variant;
								productsList.push(productdetails);
							}
						});
					}

					pushToDataLayer({
						"currencyCode": currencyCode,
						"eeAction": "eeListView",
						"event": "eeListView",
						"pageCategory": pageInfo.pageCategory,
						"products": productsList
					});
				}
			}
			
			if ($(".plp-cross-sell").length > 0) {
				const result = isScrolledIntoView(".plp-cross-sell");
				if (result && unbindRecomm < 1) {
					unbindRecomm = 1;
					
					pushToDataLayer({
						"currencyCode": currencyCode,
						"eeAction": "eeListView",
						"event": "eeListView",
						"pageSubCategory": pageInfo.pageSubCategory,
						"pageCategory": pageInfo.pageCategory,
						"products": crosssellProducts($(".plp-cross-sell").find('.recommendation-item'), "Einstein", "Product List Page")
					});
				}
			}
		})

		// Click on Reviews in PDP
		.on("click", ".product-detail-bv", function () {
			if(unbind < 1) {
				unbind = 1;
				pushToDataLayer({
					event: "productReviewsView",
					page: window.location.pathname,
					productCategory: getProductCategory(),
					productName: getProductName(),
					pageCategory: "Product Page",
					pageSubCategory: pageInfo.pageSubCategory
				});
			}
		})

		.on("click", "#pdp-swatches li.remaining-count, .custom-dd-disabled .custom-dd-list-item-selected", function (e) {
			e.preventDefault();
			if (pageInfo.pageCategory == "Product Page") {
				pushToDataLayer({
					"event": "productInteraction",
					"productName": $("h1#products-name").html().trim(), 
					"productId": getProductID(),
					"interactionType" : "open_shade_drawer"
				})
			}
		})

		// add to cart PDP , Compareshades , persistant tray
		.on('click', '.add-to-cart, .mini-add-to-cart, .compare-shades-add-to-cart', function (e) {
			if($(this).parents().hasClass('regimenzone')){
				return;
			}
			if(!$(this).parents('.recommendation-item').length && !$(this).parents('.minicart-recommendations').length) {
				if(pageInfo.pageCategory == "Checkout Page"){
					if(sessionStorage.getItem("cartupdate")){
						sessionStorage.setItem("productUpdate","1");
					}
				} else {
					window.productCache = window.productCache || {};
					var pproductOrderType = "";
					if ($(this).data("replenishable") && $(this).data("replenishable").toUpperCase() == "NO"){
						pproductOrderType= "Regular";					
					}
					else {
						pproductOrderType= "Replenishment";
					}
					
					var siteLocation="Product Page";
					if($(this).parents('.persistant-tray-product-info').length){
						siteLocation="Product Page-Persistent tray";
					}				
					else if ($(this).parents('.compare-shades-product').length){
						siteLocation="Product Page-Compare shade";
					}
					else if ($(this).parents('.pdp-quickview').length){
						siteLocation="Product Landing Page-Quickview";
					}				
					
					else if ($(this).hasClass(".compare-shades-add-to-cart")){
						siteLocation="Product Page-Compare shade";
					}
						
					var productNumReviews = 0;
					if($('.bv-primarySummary-rating-container .bv-rating-ratio-count').length > 0) {
						productNumReviews = $('.bv-primarySummary-rating-container .bv-rating-ratio-count span:last').text().trim();
					}
					var productStarRating = 0;
					if($('.bv-primarySummary-rating-container .bv-rating').length > 0) {
						productStarRating = $('.bv-primarySummary-rating-container .bv-rating span:last').text().trim();
					}
					var addToCartType;
					if($(this).parents().hasClass('regimenzone')) {
						addToCartType = "Add to Bag - Regimen";
					} else if($(this).parents().hasClass('immersive-experience')) {
						addToCartType = "pdp_overlay_explicit"
					} else {
						pageInfo.pageCategory;
					}
					pushToDataLayer({
						"currencyCode": currencyCode,
						"event": "addToCart",
						"productOrderType": getProductOrederType(),
						"addToCartType": addToCartType,
						"pageCategory": pageInfo.pageCategory,
						"pageSubCategory": pageInfo.pageSubCategory,
						"siteLocation": siteLocation,
						'products': [{
						"id": $("#pdpMain").data("masterid"),
						"category": window.productCache.catid,
						"price": Number($(this).data("price")),
						"name": getProductName(),
						"brand": getProductBrand(),
						"listName": window.productCache.listName,
						"listType" : pageInfo.pageCategory,
						"quantity": Number($(".quantity select").val()),
						"size": $("#pdp-swatches li.selected").text().trim(),
						"subCategory" : window.productCache.subcategory,
						"subSubCategory" : window.productCache.subsubcategory,
						"productAutoReplen":$(this).data("replenishable"),
						"productOrderType": pproductOrderType,
						"productOutOfStock": $(this).data("instock"),
						"productColor": $("#va-color option:selected").text().split("/")[0].trim(),
						"productType": "Product",
						"productVariantID": getProductID(),					
						"productNumReviews": productNumReviews,
						"productStarRating": productStarRating}]
					});
				}
			}	
		}) 

		// A1: Top‐filter button opens overlay
		.on('click', '.filter-mobile-tablet .filter-button', function () {
			if (!isMobile()) { return; }
			pushToDataLayer({
				event: 'PLPInteractions',
				interactionType: 'filter_overlay',
				filterSelection: $(this).text().trim()
			});
		})
		
		// A2: “View Results” — one push per checked detail
		.on('click', '.filter-display-results-btn', function () {
			if (!isMobile()) return;

			// 1) Category name from the panel header
			const category = $('.filter-panel-title').text().trim();

			// 2) All selected <li>s
			const $selectedItems = $('.filter-options-list li.filter-list-item.selected');
			if ($selectedItems.length === 0) return;
			
			// 3) One dataLayer push per selected <li>
			$selectedItems.each(function () {
				let detailText = $(this).find('span.text').text().trim();
				pushToDataLayer({
				event:           'PLPInteractions',
				pageCategory:    pageInfo.pageCategory,
				pageSubCategory: pageInfo.pageSubCategory,
				interactionType: 'filter',
				filterSelection: category,
				filterDetailsSelection: detailText
				});
			});
		})

		// A3: “Clear all” click
		.on('click', '.filter-clear-results-btn', function () {
			if (!isMobile()) { return; }
			pushToDataLayer({
				event: 'PLPInteractions',
				pageCategory:    pageInfo.pageCategory,
				pageSubCategory: pageInfo.pageSubCategory,
				interactionType: 'clear_filter'
			});
		})

		//PLP filter change
		.on("selectmenuchange change", ".slp-filters .top-filter select", function (event, ui) {
			pushToDataLayer({
				"event": "dropDownChoice",
				"dropDownType": "Sort By",
				"filterChoice": $.trim($(".sort-by select").find(":selected").text().replace(/[\t\n]+/g,' '))
			});
		})

		.on('click', ".grid-switch-wrapper button, .breadcrumb-relax, .clear-all-container",function(e){
			pushToDataLayer({
				"event": "PLPInteractions",
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory,	
				"interactionType": $(this).attr('id') == 'grid-view' ? 'view grid' : 'view unit',
				"filterSelection": '',
				"filterDetailsSelection": ''
			})
		})

		.on('click', "li .filter-option", function (e) {
			if(!$(this).hasClass("selected")){			
				var filterSelection = $.trim($(this).closest('div.filter').find('.accordion-title').text().replace(/[\t\n]+/g,' '));
				var filterDetailsSelection = $(".seected-refinements-list li").map(function() {
					return $.trim(this.innerText.replace(/[\t\n]+/g,' '));
				}).get();
				
				filterDetailsSelection = filterDetailsSelection.toString();
				filterDetailsSelection = filterDetailsSelection != '' ? filterDetailsSelection+","+$.trim($(this).text().replace(/[\t\n]+/g,' ')) : $.trim($(this).text().replace(/[\t\n]+/g,' '));
			
				pushToDataLayer({
					"event": "PLPInteractions",
					"pageSubCategory": pageInfo.pageSubCategory,
					"pageCategory": pageInfo.pageCategory,
					"interactionType":"filter",
					"filterSelection" : filterSelection.toString(),
					"filterDetailsSelection" : filterDetailsSelection
				});
			}		
				
		})


		// add to cart regimen
		.on("click",".regimenzone .product-tile  a.product-tile-wrapper .add-to-cart, .regimenzone .product-tile .add-to-bag-wrapper .add-to-cart",function(e){
			var $gtmProductTile = $(this).parents(".product-tile").find('.gtm-product-tile');
			var tileVariantData = $gtmProductTile.data('value');
			var position = $(".regimenzone .product-tile a.product-tile-wrapper").index($(this)) + 1;
			
					var siteLocation="Product Page";
					if($(this).parents('.persistant-tray-product-info').length){
						siteLocation="Product Page-Persistent tray";
					}				
					else if ($(this).parents('.compare-shades-product').length){
						siteLocation="Product Page-Compare shade";
					}
					else if ($(this).parents('.pdp-quickview').length){
						siteLocation="Product Landing Page-Quickview";
					}				
					
					else if ($(this).hasClass(".compare-shades-add-to-cart")){
						siteLocation="Product Page-Compare shade";
					}
	
					pushToDataLayer({
						"event": "addtocart",
						"pageCategory": pageInfo.pageCategory,
						"addToCartType": "Add to Bag - Regimen",
						"currencyCode": currencyCode,
						"pageCategory": pageInfo.pageCategory,
						"pageSubCategory": pageInfo.pageSubCategory,
						"siteLocation": siteLocation,
						'products': [{
							"listType": "Regimen",
							"listName": pageInfo.pageCategory,
							"list": pageInfo.pageCategory,
							"position" : position,
							"id": tileVariantData.masterID,
							"productVariantID": tileVariantData.master ? tileVariantData.defalutvariant : tileVariantData.ID,
							"category": tileVariantData.catid,
							"price": tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice,
							"name": tileVariantData.name,
							"brand": tileVariantData.brand,
							"quantity": $(this).parents(".product-tile").find('.quantity select').val(),
							"size": tileVariantData.size,
							"subCategory": tileVariantData.subcategory,
							"subSubCategory": tileVariantData.subsubcategory,
							"productAutoReplen": tileVariantData.productautoreplenish,
							"productOutOfStock": tileVariantData.productOutOfStock,
							"productColor": tileVariantData.productColor,
							"productType": "Product",
							"collectionName": tileVariantData.customBrand,
							"productNumReviews": tileVariantData.productNumReviews,
							"productOrderType": getProductOrederType(),
							"productStarRating": tileVariantData.productStarRating
						}]
					});
		}) 


		.on("click","#recommendation-slick-carousel .carousel-recommendations .recommendation-item .add-to-cart",function(e){
			var index = $(this).parents(".recommendation-item.slick-slide").attr('data-slick-index');			
			var variationId = $('#pid').val();
			var variationName = $(this).parents(".product-info-content").find(".selected .swatchanchor").data("name");
				if(typeof prodData.product[index] != undefined && prodData.product[index] != null ){
					var siteLocation="Product Page";
					if($(this).parents('.persistant-tray-product-info').length){
						siteLocation="Product Page-Persistent tray";
					}				
					else if ($(this).parents('.compare-shades-product').length){
						siteLocation="Product Page-Compare shade";
					}
					else if ($(this).parents('.pdp-quickview').length){
						siteLocation="Product Landing Page-Quickview";
					}				
					
					else if ($(this).hasClass(".compare-shades-add-to-cart")){
						siteLocation="Product Page-Compare shade";
					}
					if(!$(this).closest('.plp-cross-sell').length) {
						pushToDataLayer({
							"event": "addToCart",
							"addToCartType": "Add to Bag - Einstein",
							"currencyCode": currencyCode,
							"pageCategory": pageInfo.pageCategory,
							"pageSubCategory": pageInfo.pageSubCategory,
							"siteLocation": siteLocation,
							'products': [{
								"name": prodData.product[index].name,
								"id": prodData.product[index].id,
								"productVariantID": variationId,
								"price": prodData.product[index].price,
								"brand": getProductBrand(),
								"category": prodData.product[index].category,
								"subCategory" : prodData.product[index].subCategory,
								"subSubCategory" : prodData.product[index].subSubCategory,
								"quantity": prodData.product[index].quantity,
								"productAutoReplen": prodData.product[index].productAutoReplen,
								"productOutOfStock": prodData.product[index].productOutOfStock,
								"productNumReviews": prodData.product[index].prodNumReviews,
								"productStarRating": prodData.product[index].prodStarRating,
								"productColor": variationName,
								"productOrderType": getProductOrederType(),
								"productType": prodData.product[index].productType
							}]
						})
					}
					sessionStorage.setItem('listType',prodData.product[index].listType);
					sessionStorage.setItem('listName',prodData.product[index].listName);
				}
		})
		// Add to all to Cart
		.on("click", ".regimenzone.add-all", function () {
			var $regimenbg = $(".regimenzone").find(".regimen-container");	
			var productsList = [];
			$regimenbg.find('.gtm-product-tile').each(function () {
				var product = {};
				var tileVariantData = $(this).data('value');
				product.ID = tileVariantData.masterID || tileVariantData.ID;
				product.productVariantID = tileVariantData.ID;
				product.category = tileVariantData.catid;
				product.price = tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice;
				product.name = tileVariantData.name;
				product.brand = tileVariantData.brand;
				product.quantity = productCache.productSet ? $("#quantity").val() : tileVariantData.quantity;
				product.size = tileVariantData.size;
				product.subCategory = tileVariantData.subcategory;
				product.subSubCategory = tileVariantData.subsubcategory;
				product.productAutoReplen = tileVariantData.productautoreplenish;
				product.productOutOfStock = tileVariantData.productOutOfStock;
				product.productColor = tileVariantData.productColor;
				product.productType = "Product";
				product.collectionName = tileVariantData.customBrand;
				product.productNumReviews = tileVariantData.productNumReviews;
				product.productStarRating = tileVariantData.productStarRating;
				product.productOrderType = getProductOrederType();
				productsList.push(product);
			});
			
			
			pushToDataLayer({
				"currencyCode": currencyCode,
				"event": "addToCart",
				"addToCartType": "Add All to Bag - Regimen",
				"pageSubCategory": getProductsubCategory(),
				"pageCategory": pageInfo.pageCategory,
				"products": productsList
			});
		})	
		
		// Submit ask a question
		.on('click', ".bv-submission-section button:contains('Post Question')" , function(e){
				pushToDataLayer({
					"page": pageInfo.pageCategory,
					"event": "submitQuestion",
					"productCategory": getProductCategory(),
					"question": $("#bv-textarea-field-questionsummary").val(),
					"productName": getProductName(),
					"pageSubCategory": pageInfo.pageSubCategory,
					"pageCategory": pageInfo.pageCategory
					});
		})
		
		// remove from cart
		.on('click', ".item-user-actions .btn-remove-cart-item", function (e) {
			var index = $(this).parents(".cart-row").index();
			var $cartRedesign = $('.cart_page');
			if ($cartRedesign.length) {
				removeProductFromCart(index, basketConfirmation.productLineItems[index-1].quantity);
			} else {
				removeProductFromCart(index-1, basketConfirmation.productLineItems[index-1].quantity);
			}
			
		})

        // eeListClick datalayer for minicart
        .on("click", ".mini-cart-product .mini-cart-image, .mini-cart-product .mini-cart-name", function () {
            if($(this).hasClass('mini-cart-name')){
                var position = $(".mini-cart-product .mini-cart-name").index($(this)) + 1;
            } else{
                var position = $(".mini-cart-product .mini-cart-image").index($(this)) + 1;
            }
			
             var pid = $(this).parents('.mini-cart-product').find('.remove-link').data('pid');

			 var products = [];
			 for(var i = 0; i < miniCartConfirmation.productLineItems.length; i++) {
                if(miniCartConfirmation.productLineItems.length && miniCartConfirmation.productLineItems[i].productVariantID == pid) {
					var productlistdata = {
						"name" : miniCartConfirmation.productLineItems[i].name,
						"id" : miniCartConfirmation.productLineItems[i].id,
						"price" : miniCartConfirmation.productLineItems[i].price,
						"brand" : getProductBrand(),
						"category" : miniCartConfirmation.productLineItems[i].category,
						"subCategory" : miniCartConfirmation.productLineItems[i].subCategory,
						"subSubCategory": miniCartConfirmation.productLineItems[i].subSubCategory,
						"position":position,
						"listType" : "Mini Cart",
						"listName" : "Articles in cart",
						"productAutoReplen" : miniCartConfirmation.productLineItems[i].productautoreplenish,
						"productOutOfStock" : miniCartConfirmation.productLineItems[i].productOutOfStock,
						"productNumReviews" : miniCartConfirmation.productLineItems[i].productNumReviews,
						"productStarRating" : miniCartConfirmation.productLineItems[i].productStarRating,
						"productColor" : miniCartConfirmation.productLineItems.productColor,
						"productType" : miniCartConfirmation.productLineItems[i].productType,
						"productVariantID" : miniCartConfirmation.productLineItems[i].productVariantID,
						"productBundle" : miniCartConfirmation.productLineItems[i].productBundle
					}

					products.push(productlistdata);
					break;
                }
            }

			var cartName = $('.mini-cart-product').find('.mini-cart-name a').attr('href');
			var cartImg = $('.mini-cart-product').find(".mini-cart-image a").attr("href");
                pushToDataLayer({
                    "currencyCode": currencyCode,
                    "pageSubCategory": pageInfo.pageSubCategory,
                    "event": "eeListClick",
                    "pageCategory": pageInfo.pageCategory,
                    'products': products
            })
        })
        // cartClicked datalayer for minicart and nav
        .on("click", ".minicart-wrapper .mini-cart-link-cart, .minicart-wrapper .mini-cart-total .mini-cart-link", function () {
            if($(this).hasClass('mini-cart-link')){
                var cartClicked = "navCart";
            } else{
                var cartClicked = "miniCart";
            }
            localStorage.setItem("cartClicked", cartClicked);
    	})
        // remove from minicart
        .on('click', ".mini-cart-details .remove-link", function (e) {
			var pid = $(this).data('pid');

			 var products = [];
			 for(var i = 0; i < miniCartConfirmation.productLineItems.length; i++) {
                if(miniCartConfirmation.productLineItems.length && miniCartConfirmation.productLineItems[i].productVariantID == pid) {
					var productlistdata = {
						"name": miniCartConfirmation.productLineItems[i].name,
						"id": miniCartConfirmation.productLineItems[i].id,
						"price": miniCartConfirmation.productLineItems[i].price,
						"brand": getProductBrand(),
						"category": miniCartConfirmation.productLineItems[i].category,
						"subCategory" : miniCartConfirmation.productLineItems[i].subCategory,
						"subSubCategory": miniCartConfirmation.productLineItems[i].subSubCategory,
						"quantity": miniCartConfirmation.productLineItems[i].quantity,
						"productColor":  miniCartConfirmation.productLineItems[i].productColor,
						"productOrderType": miniCartConfirmation.productLineItems[i].productOrderType,
						"productType": miniCartConfirmation.productLineItems[i].productType,
						"productAutoReplen": miniCartConfirmation.productLineItems[i].productAutoReplen,
						"productVariantID": miniCartConfirmation.productLineItems[i].productVariantID
					}

					products.push(productlistdata);
					break;
                }
            }

			pushToDataLayer({
				"event": "removeFromCart",
				"currencyCode": currencyCode,
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				'products': products,
				'siteLocation': 'product page'
		})
        })
		
		// remove from cart on quantity reduce on cart page
		.on('change', '.item-quantity select', function() {
			var index = $(this).parents(".cart-row").index();
			var newQty = Number($('.item-quantity select:first').val());
			var oldQty = basketConfirmation.productLineItems[index-2].quantity;
			
			if(newQty < oldQty) {
				removeProductFromCart(index, newQty);
			} else {
				pushToDataLayer({
					"currencyCode": currencyCode,
					"event": "addToCart",
					"addToCartType": pageInfo.pageCategory,
					"pageSubCategory": pageInfo.pageSubCategory,
					"pageCategory": pageInfo.pageCategory,
					"siteLocation": "Wish List Page",
					'products': [{
					"id": basketConfirmation.productLineItems[index-1].id,
					"category": basketConfirmation.productLineItems[index-1].category,
					"price": basketConfirmation.productLineItems[index-1].price,
					"name": basketConfirmation.productLineItems[index-1].name,
					"brand": basketConfirmation.productLineItems[index-1].brand,
					"quantity": newQty,
					"size": basketConfirmation.productLineItems[index-1].size,
					"subCategory" : basketConfirmation.productLineItems[index-1].subCategory,
					"subSubCategory" : basketConfirmation.productLineItems[index-1].subSubCategory,
					"productOrderType": basketConfirmation.productLineItems[index-1].productOrderType,
					"productAutoReplen":basketConfirmation.productLineItems[index-1].productAutoReplen,
					"productOutOfStock": basketConfirmation.productLineItems[index-1].productOutOfStock,
					"productColor": basketConfirmation.productLineItems[index-1].color,
					"productType": "Product",
					"productVariantID": $(this).data("variantid"),
					"productNumReviews":$(this).data("prodnumreviews"),
					"productStarRating":$(this).data("prodstarrating")}]
					});
			}
			
		})
		
		// tracking change on image from image carousel in 
		.on('click', ".product-primary-image button.slick-arrow, .product-primary-image .slick-dots button",function(e){
			e.stopPropagation();
			pushToDataLayer({
				"event": "productInteraction",
				"productCategory": window.productCache.catid,
				"productSubCategory": window.productCache.subcategory,
				"productName": getProductName(),
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				"id": $("#pdpMain").data("masterid"),
				"productVariantID": getProductID(),				
				"interactionType" : "Change Images"
				
			})
		})	
		// tracking click on arrow from image thumbnail on PDP 
		.on('click', '.product-thumbnails button.slick-next, .product-thumbnails button.slick-prev', function (e) {

			pushToDataLayer({
				"event": "productInteraction",
				"productCategory": getProductCategory().split('\n').shift(),
				"productSubCategory": getProductsubCategory().split('\n').shift(),
				"productName": $(".product-title .product-name").text(),
				"pageCategory": pageInfo.pageCategory,
				"productId": productCache.variant ? productCache.masterID : productCache.ID,
				"productVariantID": getProductID(),
				"interactionType" : "Change Image"
			})
		})
		
		// click zoom in pdp
		.on('click', ".slider-main-image", function (e) {
			pushToDataLayer({
				"event": "productInteraction",
				"productCategory": getProductCategory(),
				"productSubCategory": getProductsubCategory(),
				"productName": getProductName(),
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				"id": $("#pdpMain").data("masterid"),
				"productVariantID": getProductID(),
				"interactionType" : "Zoom"
			})

		})
		
		// click full ingredients in pdp
		.on('click', ".pdp-content-section .full-ingredients", function(e) {
			pushToDataLayer({
				"event": "productInteraction",
				"productCategory": getProductCategory(),
				"productSubCategory": getProductsubCategory(),
				"productName": getProductName(),
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				"id": $("#pdpMain").data("masterid"),
				"productVariantID": getProductID(),
				"interactionType" : "View Full Product Ingredients"
			})
		})

		//click on pdp accordion
		.on('click', ".pdp-content.accordion .accordion-title", function(e) {
			if($(this).hasClass('active')) {
				var interactionTypeText = $(this).contents().filter(function() {
					return this.nodeType === 3; // Select text nodes
				}).text().trim();
				pushToDataLayer({
					"event": "productInteraction",
					"productCategory": getProductCategory(),
					"productSubCategory": getProductsubCategory(),
					"pageSubCategory": pageInfo.pageSubCategory,
					"productName": getProductName(),
					"pageCategory": pageInfo.pageCategory,
					"productId": getProductID(),
					"interactionType" : interactionTypeText
				})
			}
		})
		
		// click virtual try-on in pdp
		.on('click', ".product-action-virtual-try-on", function(e) {
			pushToDataLayer({
				"event": "productInteraction",
				"productCategory": getProductCategory(),
				"productSubCategory": getProductsubCategory(),
				"productName": getProductName(),
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				"id": $("#pdpMain").data("masterid"),
				"productVariantID": getProductID(),
				"interactionType" : "Virtual Try-On"
			})
		})
		
		.on("click", ".cart-promo-approaching", function(){
			var nextPage = $(this).attr('href');
			pushToDataLayer({
				"event": "eePromoClick",
				"nextPage": nextPage,
				"pageSubCategory": "Internal marketing",
				"pageCategory": pageInfo.pageCategory,
				'promotions': [{
				"position": "Cart",
				"id": $(".cart-promo-approaching").data("promoid"),
				"creative": "Cart-Banner",
				"name": $(".cart-promo-approaching").data("promoname")
				}]
			})
		})
		
		
		// track share button on PDP
		.on("click", ".social-sharing-container .share-icon", function() {
			pushToDataLayer({
				"socialAction": "Share",
				"event": "socialShare",
				"siteLocation": "product page",
				"pageCategory": pageInfo.pageCategory,
				"socialNetwork": $(this).data("share")
				})

		})
		
		// Track Follow button on Footer
		.on("click", ".social-links a", function() {
			pushToDataLayer({
				"socialAction": "Follow",
				"event": "socialFollow",
				"siteLocation": "footer",
				"pageCategory": pageInfo.pageCategory,
				"socialNetwork": $(this).data("follow")
				})
		})
		
		// Add to Cart in Save for later
		.on("click",".wishlist-item .add-to-cart", function(){
			var index = $(this).parents('form').index();
			pushToDataLayer({
				"currencyCode": currencyCode,
				"event": "addToCart",
				"productOrderType": getProductOrederType(),
				"addToCartType": pageInfo.pageCategory,
				"pageSubCategory": getProductsubCategory(),
				"pageCategory": pageInfo.pageCategory,
				"siteLocation": "Wish List Page",
				'products': [{
				"id": $(this).data("prodid"),
				"category": wishlistItem.product[index].category,
				"price": wishlistItem.product[index].price,
				"name": wishlistItem.product[index].name,
				"brand": wishlistItem.product[index].brand,
				"quantity": wishlistItem.product[index].quantity,
				"size": wishlistItem.product[index].size,
				"subCategory" : wishlistItem.product[index].subcategory,
				"subSubCategory" : wishlistItem.product[index].subsubcategory,
				"productAutoReplen":wishlistItem.product[index].productAutoReplen,
				"productOutOfStock": wishlistItem.product[index].productOutOfStock,
				"productColor": wishlistItem.product[index].color,
				"productType": "Product",
				"productVariantID": $(this).data("variantid"),
				"productNumReviews":$(this).data("prodnumreviews"),
				"productStarRating":$(this).data("prodstarrating")}]
				});

		})
		
		// Add to all to Cart
		.on("click",".add-all-to-cart, .mini-add-to-cart-set", function(){
			var productsArr = '';
			if(typeof productCache != 'undefined' && productCache.productSet){
				productsArr = typeof productSetCache != 'undefined' ? productSetCache : '';
								
				var $qtyfield = $(this).hasClass("mini-add-to-cart-set") ? $(this).closest('.persistant-tray-active') : $(this).closest('.product-info');
				var qty = $qtyfield.find('select[name="Quantity"]').val();
				
				for(var x=0; x < productsArr.length; x++){
					productsArr[x].quantity =  parseInt(qty);
				}
			}else{
				productsArr = typeof wishlistItem != 'undefined' ? wishlistItem.product : '';
			}
			
			pushToDataLayer({				
				"event": "addToCart",
				"productOrderType": getProductOrederType(),
				"addToCartType": pageInfo.pageCategory,
				"currencyCode": currencyCode,
				"pageSubCategory": getProductsubCategory(),
				"pageCategory": (typeof productCache != 'undefined' && productCache.productSet) ? "Product Bundle Page" : pageInfo.pageCategory,
				"siteLocation": "Wish List Page",
				"products": productsArr
				});
			
		})
		
		// Track PLP Cross Category Navigation
		.on("click", "#cross-cat-nav li a", function() {
			var $this = $(this);
            if ($this.parent('li').attr('data-category') !== 'null' && $('.pt_product-search-result').length > 0 ) {
                pushToDataLayer({
                    'event': 'list_subcategory_interaction',
                    'list_subcategory' : $this.parent('li').attr('data-category')
                });
            }
		})
		
		.on('click', '.plps-container a', function () {
			pushToDataLayer({
				'event': 'list_crossnav_top_interaction',
				'list_subcategory' : $(this).text().trim()
			});
		})
		
		// Track Top Search clicks
		.on("mousedown touchstart", ".top-searches li a", function() {			
			pushToDataLayer({
				"event" : "topSearches",
				"page": $(this).attr('href')
				})
		})
		
		// click email hyper link in navigation
		.on('click','.emailcsr-nav', function(){
			if(window.Resources.PAGE_CATEGORY == "page-show"){
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Email",
					"siteLocation": "Header",
					//"pageSubCategory": pageInfo.pageSubCategory,
					"pageCategory": getProductCategory()
					});
				
			}else{
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Email",
					"siteLocation": "Header",
					"pageSubCategory": window.Resources.PAGE_CATEGORY=="cart-show" ? "" :pageInfo.pageSubCategory,
					"pageCategory": pageInfo.pageCategory
					});
			}
			
		})
		// Click email link in the customer care
		.on("click",".content-link-container a:contains('customerservice@narscosmetics.com')",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Email",
				"siteLocation": window.Resources.PAGE_CATEGORY=="cart-show" ? "Right Nav":"Header",
				//"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": window.Resources.PAGE_CATEGORY=="cart-show" ? pageInfo.pageCategory: getProductCategory()
				});
		})
		
		.on("gtmcontactus",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Contact Customer Care Submission",
				"siteLocation": "Contact us page",
				"pageCategory": pageInfo.pageCategory
				});
		})
		.on("askanexpert",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Ask An Expert Submission",
				"siteLocation": "Ask an expert page",
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory
			});
		})
		
		.on("click",".LPMcontainer",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Live Chat",
				"siteLocation": pageInfo.pageCategory=="Checkout Page" ? "Header": "Body",
				"pageSubCategory":pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory
			});
		})
		
		.on("click",".LPMimage",function(){
			var id = $(this).attr("id");
			var chk = id.charAt(id.length - 1)
			if(chk == 1){
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Live Chat",
					"siteLocation": "Pop-up",
					"pageSubCategory":pageInfo.pageSubCategory,
					"pageCategory": pageInfo.pageCategory
				});
			}
		})

		.on("click",".footer-container .products ul li:nth-child(4)",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Phone",
				"siteLocation": "Footer",
				"pageSubCategory":window.Resources.PAGE_CATEGORY=="cart-show" ? "" :pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory
			});
		})
		
		// click on recommendation
		.on("click",".recommendation-item",function(){
			if(pageInfo.pageCategory== "Product Page"){
				sessionStorage.setItem('listType', "Recommended Product List");
				sessionStorage.setItem('listName', "Product Page");
			}else if(pageInfo.pageCategory== "Home Page"){
				sessionStorage.setItem('listType', "Recently Viewed List");
				sessionStorage.setItem('listName', "Home Page");
			}
				
		})
		
		
		.on("click",".catalog-link",function(e){
			 if(navctr==true){
				 gtmNavData = $(this).text().trim();
				 sessionStorage.setItem("navlink",gtmNavData);
				 sessionStorage.setItem("menuloc","topmenu");
				 util.setCookie('navdata',gtmNavData,.20);
				 navctr = false;
			 }
		})
		
		.on('click', '#pdpMain .custom-dd-list li', function () {
			var $this = $(this);
			const variantData = $('#pdpMain').find('.color-filter-wrapper li').filter(function() {
				return $(this).data('selectedcolor') == $this.attr('data-value');
			});
			pushToDataLayer({
				"event": "productInteraction",
				"interactionType": "select_shade_selector",
				"productCategory": $(".breadcrumb").find(".breadcrumb-element span").html(),
				"productSubCategory": $(".breadcrumb").find(".breadcrumb-element:eq(1) span").html(),
				"productName": getProductName(),
				"id": getProductID(),
				"productVariantID": variantData.find('.swatchanchor').data('variantid'),
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory
			});
		})

		.on("click",".main-nav .has-sub-menu a",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData);
			sessionStorage.setItem("menuloc","topmenu");
			util.setCookie('navdata',gtmNavData,.20);
			navctr = false;
		})

		.on("click", ".main-nav .level-2-link a", function (e) {
			gtmNavData =$(this).text().trim();
			sessionStorage.setItem("navlink", gtmNavData);
			sessionStorage.setItem("menuloc", "topmenu");
			util.setCookie('navdata', gtmNavData, .20);
			navctr = false;
		})

		.on("click", ".main-nav .level-3-link a", function (e) {
			gtmNavData =$(this).text().trim();
			sessionStorage.setItem("navlink", gtmNavData);
			sessionStorage.setItem("menuloc", "topmenu");
			util.setCookie('navdata', gtmNavData, .20);
			navctr = false;
		})

		.on("click", ".main-nav .no-sub-cat-2 a", function (e) {
			gtmNavData =$(this).text().trim();
			sessionStorage.setItem("navlink", gtmNavData);
			sessionStorage.setItem("menuloc", "topmenu");
			util.setCookie('navdata', gtmNavData, .20);
			navctr = false;
		})

		.on("click",".main-nav .no-sub-menu a",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData);
			sessionStorage.setItem("menuloc","topmenu");
			util.setCookie('navdata',gtmNavData,.20);
			navctr = false;
		})
		
		.on("click",".refinement-header",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData);
			sessionStorage.setItem("menuloc","leftmenu");
		})
		
		.on("click",".refinement-link",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData);
			sessionStorage.setItem("menuloc","leftmenu");
		})
		
		.on("click",".breadcrumb-element",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("breadcrumbs",gtmNavData);
			sessionStorage.setItem("menuloc","leftmenu");
		})
		
		.on("change","#quantity",function(e){
			if(pageInfo.pageCategory == "Checkout Page"){
				if($(".edit-modal").length > 0){
					sessionStorage.setItem("cartupdate","1");
				}else{
					sessionStorage.setItem("productUpdate","1");
				}
				
			}
			
		})
		
		.on("change",".quantity-select",function(e){
			if(window.Resources.PAGE_CATEGORY == "wishlist-show"){
				sessionStorage.setItem("productUpdate","1");
			}
		})
		
		.on("click",".account-left-nav li",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData);
			sessionStorage.setItem("menuloc","leftmenu");
		})
		
		// Remove uservalidation attribute for userlogin validation
		.on('click', ".user-logout", function (e) {
			localStorage.removeItem('uservalidation');
			sessionStorage.removeItem('userRegistered');
			localStorage.removeItem("storeDetailsSection");
			localStorage.removeItem("selectedStoreData");
			localStorage.removeItem("royalMail-edit");
			localStorage.removeItem("storedAddressData");
		})
		
		.on("change","#va-color",function(){
			if($(".regimenzone").find(".regimen-container").length > 0){
				return;
			}
			if(pageInfo.pageCategory == "Checkout Page"){
				sessionStorage.setItem("cartupdate","1");
			}
			pushToDataLayer({
				"event": "productInteraction",
				"productCategory": window.productCache.catid,
				"productSubCategory": window.productCache.subcategory,
				"productName": getProductName(),
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				"id": $("#pdpMain").data("masterid"),
				"productVariantID": getProductID(),				
				"interactionType" : "Drop-Down Shade Change"					
			});			
		})
		
		.on("click",".close-button",function(){
			if(pageInfo.pageCategory == "Checkout Page"){
				sessionStorage.setItem("cartupdate","");
			}
		})
		
		.on("click","#save-for-later",function(){
			if(pageInfo.pageCategory == "Checkout Page"){
				sessionStorage.setItem("cartupdate","");
			}
		})
		
		.on('update-gtm',function(data){
			if(pageInfo.pageCategory == "Checkout Page"){
				if(!$(data).hasClass("selected")){
					sessionStorage.setItem("cartupdate","1");
				}
			}
			if(pageInfo.pageCategory != "Product Page") {
				pushToDataLayer({
					"event": "productInteraction",
					"productCategory": window.productCache.catid,
					"productSubCategory": window.productCache.subcategory,
					"productName": getProductName(),
					"pageCategory": pageInfo.pageCategory,
					"pageSubCategory": pageInfo.pageSubCategory,
					"id": $("#pdpMain").data("masterid"),
					"productVariantID": getProductID(),				
					"interactionType" : "Swatch Shade Change"
				})
			}
		})
		
		.on("click",".search-suggestion-wrapper .hit",function(){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData.replace(/\s\s+/g, ' '));
			sessionStorage.setItem("menuloc","site search pop-in");
		})
		
		.on("click",".search-suggestion-wrapper .product-suggestion",function(){
			gtmNavData = $(this).text().trim();
			var rep = gtmNavData.replace(/\n/g," "); 
			sessionStorage.setItem("navlink",rep.replace(/ +/g," "));
			sessionStorage.setItem("menuloc","site search pop-in");
		})
		
		// PLP click in list — thumbnail
		.on("click", ".product-tile-main-wrapper .thumb-link", function () {
			if(!$(this).closest('.plp-cross-sell').length) {
				const $tile    = $(this).closest(".product-tile-main-wrapper");
				const raw      = $tile.find("input.gtm-product-tile");
				const data     = raw.data("value") || JSON.parse(raw.attr("data-value") || {});
				const nextPage = $(this).attr("href");
			
				// --- normalize into staging shape ---
				const prod = {
					brand:             data.brand          || data.customBrand,
					category:          data.category       || data.catid               || data.categoryID,
					categoryID:        data.categoryID     || data.catid,
					color:             data.color          || data.productColor,
					id:                data.productVariantID || data.ID        || data.masterID,
					listName:          listName(),
					listType:          listType(),
					name:              data.name,
					position:          data.position       || 0,
					price:             data.price          || (data.pricing?.sale)     || 0,
					productAutoReplen: data.productAutoReplen || data.replenishmentCycle || "No",
					productOutOfStock: data.productOutOfStock || (data.availability?.inStock ? "in-stock" : "out-of-stock"),
					productColor:      data.productColor,
					productType:       data.productType,
					productVariantID:  data.productVariantID,
					quantity:          data.quantity       || 1,
					subCategory:       data.subCategory    || data.subcategory,
					subCategoryID:     data.subCategoryID  || data.subcategoryID,
					variant:           data.variant        || ""
				};
			
				pushToDataLayer({
					event:          "eeListClick",
					nextPage:       nextPage,
					pageSubCategory: pageInfo.pageSubCategory,
					pageCategory:   pageInfo.pageCategory,
					filterChoice:   getActiveSortingRule(),
					dropDown:       getRefinementsFromURL(),
					products:       [ prod ]
				});
			
				// preserve for next “productDetail” event
				sessionStorage.setItem("listType", listType());
				sessionStorage.setItem("listName", listName());
			}
		})
		
		// PLP click in list — name or tile link
		.on("click", ".product-tile-main-wrapper a.product-link", function (e) {
			const $this = $(this);
			if(!$this.parents('.search-result-items').length) {
				return;
			}
		
			const $el      = $(this);
			const $tile    = $el.closest(".product-tile-main-wrapper");
			const raw      = $tile.find("input.gtm-product-tile");
			const data     = raw.data("value") || JSON.parse(raw.attr("data-value") || {});
			const nextPage = $el.attr("href");
		
			// normalize IDs first
			const idVal  = data.id               || data.ID       || data.masterID;
			const vidVal = data.productVariantID || data.variantID || idVal;
			if (!idVal) {
				console.error("[PLP] no tileData.id — check selector!", data);
			return;
			}
			data.id               = idVal;
			data.productVariantID = vidVal;
		
			// --- normalize into staging shape ---
			const prod = {
				brand:             data.brand          || data.customBrand,
				category:          data.category       || data.catid               || data.categoryID,
				categoryID:        data.categoryID     || data.catid,
				color:             data.color          || data.productColor,
				id:                idVal,
				listName:          listName(),
				listType:          listType(),
				name:              data.name,
				position:          data.position       || 0,
				price:             data.price          || (data.pricing?.sale)     || 0,
				productAutoReplen: data.productAutoReplen || data.replenishmentCycle || "No",
				productOutOfStock: data.productOutOfStock || (data.availability?.inStock ? "in-stock" : "out-of-stock"),
				productColor:      data.productColor,
				productType:       data.productType,
				productVariantID:  vidVal,
				quantity:          data.quantity       || 1,
				subCategory:       data.subCategory    || data.subcategory,
				subCategoryID:     data.subCategoryID  || data.subcategoryID,
				variant:           data.variant        || ""
			};
		
			pushToDataLayer({
				eeAction:       "eeListClick",
				event:          "eeListClick",
				nextPage:       nextPage,
				pageSubCategory: pageInfo.pageSubCategory,
				pageCategory:   pageInfo.pageCategory,
				filterChoice:   getActiveSortingRule(),
				dropDown:       getRefinementsFromURL(),
				products:       [ prod ]
			});
		
			sessionStorage.setItem("listType", listType());
			sessionStorage.setItem("listName", listName());
		}) 

		// Recommendation, bestseller eelistclick in homepage,pdp,cart
		.on("click","#recommendation-slick-carousel .pi .recommendation-item",function(e){	
			var index = $(this).index() + 1;
			var nextPage = $(this).find(".product-tile").data('url');
			var productID = $(this).find(".product-tile").data('itemid');
			var trackingID = $(this).find(".product-tile").data('trackingid');
			var url = $(this).find(".product-tile").data('url');			
			
			if ($('#recommendation-slick-carousel .pi .recommendation-item .add-to-cart').length > 0) {
				return;
			}

			if($(this).closest('.plp-cross-sell').length) {
				pushToDataLayer({
					"currencyCode": currencyCode,
					"eeAction": "eeListClick",
					"event": "eeListClick",
					"pageSubCategory": pageInfo.pageSubCategory,
					"pageCategory": pageInfo.pageCategory,
					"products": crosssellProducts($(this), "Einstein", "Product List Page")
				});
			} else if (prodData?.product?.[index] != undefined && prodData.product[index] != null) {
				const selectedProduct = prodData.product[index - 1];
			
				pushToDataLayer({
					event: "eeListClick",
					nextPage: nextPage,
					pageSubCategory: pageInfo.pageSubCategory,
					pageCategory: pageInfo.pageCategory,
					products: [{
						listType: "Einstein",
						listName: getPageName(),
						list: `Einstein > ${getPageName()}`,
						position: selectedProduct.position,
						productVariantID: selectedProduct.productVariantID,
						id: selectedProduct.id,
						category: selectedProduct.category,
						price: selectedProduct.price,
						name: selectedProduct.name,
						brand: getProductBrand(),
						quantity: selectedProduct.quantity,
						size: selectedProduct.size,
						subCategory: selectedProduct.subCategory,
						subSubCategory: selectedProduct.subSubCategory,
						productAutoReplen: selectedProduct.productAutoReplen,
						productOutOfStock: selectedProduct.productOutOfStock,
						productColor: selectedProduct.color,
						productType: selectedProduct.productType,
						productNumReviews: selectedProduct.prodNumReviews,
						productStarRating: selectedProduct.prodStarRating
					}]
				});
			
				// Store listType and listName in sessionStorage for current product
				const { listType, listName } = prodData.product[index];
				sessionStorage.setItem('listType', listType);
				sessionStorage.setItem('listName', listName);
			}
		})

		.on("click","#recommendation-slick-carousel .carousel-recommendations .recommendation-item .swatchanchor",function(e){
			e.preventDefault();
			e.stopPropagation();
			var variantid = $(this).data("pid");
                pushToDataLayer({
                    "event": "productInteraction",
					"interactionType": "change product variation",
					"productCategory": getProductCategory(),
					"productSubCategory": getProductsubCategory(),
					"productName": getProductName(),
					"productId": $("#pdpMain").data("masterid"),
					"productVariantID": variantid, 
					"pageCategory": pageInfo.pageCategory,
					"pageSubCategory": pageInfo.pageSubCategory
                })
        })
		

		// Recently viewed eelistclick in homepage
		.on("click",".cross-sell #recommendation-slick-carousel .carousel-recommendations ul .recommendation-item",function(e){
			var index = $(this).index()-3;
			var nextPage = $(this).attr('href');
			if(typeof prodData.product[index] != undefined && prodData.product[index] != null ){
				pushToDataLayer({
					"event": "eeListClick",
					"nextPage": nextPage,
					"pageSubCategory": pageInfo.pageSubCategory,
					"pageCategory": pageInfo.pageCategory,
					'products': [{
					"listType" : prodData.product[index].listType,
					"listName": prodData.product[index].listName,
					"position": prodData.product[index].position,
					"id": prodData.product[index].id,
					"productVariantID": prodData.product[index].productVariantID,
					"category": getProductCategory(),
					"price": prodData.product[index].price,
					"name": prodData.product[index].name,
					"brand": getProductBrand(),
					"quantity": prodData.product[index].quantity,
					"size": prodData.product[index].size,
					"subCategory" : prodData.product[index].subCategory,
					"subSubCategory" : prodData.product[index].subSubCategory,
					"productAutoReplen": prodData.product[index].productAutoReplen,
					"productOutOfStock": prodData.product[index].productOutOfStock,
					"productColor": prodData.product[index].productColor,
					"productType": prodData.product[index].productType,
					"productNumReviews": prodData.product[index].prodNumReviews,
					"productStarRating": prodData.product[index].prodStarRating}]
				})
				sessionStorage.setItem('listType',prodData.product[index].listType);
                sessionStorage.setItem('listName',prodData.product[index].listName);
			}
		})
		
		// click on viewmore button
		.on("plpviewmore",function(e){
			if(pageInfo.pageCategory == "Category Page" || pageInfo.pageCategory == "Product List Page" || pageInfo.pageCategory == "Search Show" || pageInfo.pageCategory == "Site Search"){
				if(prodholder && productData.product != undefined){
					if(productData.length && prodholder[0].length){
						prodholder = prodholder[0].concat(productData.product);
					}else{
						prodholder = prodholder.concat(productData.product);						
					}
					
					
					for(var i=0;i<prodholder.length;i++){
						prodholder[i].position = i+1;
					}
					for(var a=0;a<productData.product.length;a++){
						var diff =  productData.product.length - a;
						productData.product[a].position = (prodholder.length - diff) + 1;
					}
					pushToDataLayer({
			                    "event": "eeListView",
			                    "eeAction": "eeListView",
			                    "pageCategory": searchItems.search ? "Site Search" :"Product List Page",
			                    "dropDown": "",
			                    "filterChoice": "",
			                    "currencyCode" : window.User.currencyCode,
			                    "products": productData && productData.product || new Array()
			        });
				}
			}
			
		})

		// tracking change on image in 
		.on("clickproductthumbnail",function(){
			pushToDataLayer({
				"event": "productInteraction",
				"productCategory": window.productCache.catid,
				"productSubCategory": window.productCache.subcategory,
				"productName": getProductName(),
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				"id": $("#pdpMain").data("masterid"),
				"productVariantID": getProductID(),				
				"interactionType" : "Image Change"
					
			})
		})

		// click on next arrow recommendation carousel and best seller
		.on("click","#recommendation-slick-carousel .carousel-recommendations .slick-next:not(.slick-arrow)",function(e){
			if(typeof prodData != undefined && prodData != null && prodData.product && !$(this).closest('.plp-cross-sell').length){
				var tempProd = [];
			    var tempInd = 0;			    
			    $('#recommendation-slick-carousel ul.carousel-recommendations li.recommendation-item').each(function(i){   
			    	if($(this).attr('aria-hidden') == "false"){
			    		tempInd = $(this).attr('data-slick-index');
			    		
			    		prodData.product[tempInd].price = parseFloat($(this).find(".product-pricing").find(".price-sales").attr("content"));
			    		tempProd.push({
							"listType" : "Einstein",
							"list": `${"Einstein"} > ${getPageName()}`,
							"listName": getPageName(),
							"position": prodData.product[tempInd].position,
							"id": prodData.product[tempInd].id,
							"productVariantID": prodData.product[tempInd].productVariantID,
							"category": prodData.product[tempInd].category,
							"price": prodData.product[tempInd].price,
							"name": prodData.product[tempInd].name,
							"brand": getProductBrand(),
							"quantity": prodData.product[tempInd].quantity,
							"size": prodData.product[tempInd].size,
							"subCategory" : prodData.product[tempInd].subCategory,
							"subSubCategory" : prodData.product[tempInd].subSubCategory,
							"productAutoReplen": prodData.product[tempInd].productAutoReplen,
							"productOutOfStock": prodData.product[tempInd].productOutOfStock,
							"productColor": prodData.product[tempInd].color,
							"productType": prodData.product[tempInd].productType,
							"productNumReviews": prodData.product[tempInd].prodNumReviews,
							"productStarRating": prodData.product[tempInd].prodStarRating
						});
			    	}
			    		  
			    });
			    
				pushToDataLayer({
					"currencyCode": window.User.currencyCode,
					"eeAction": "eeListView",
					"event" : "eeListView",
					"pageCategory": pageInfo.pageCategory,
					"products": tempProd 
				});
            }
		})
		
		.on("click","#recommendation-slick-carousel .carousel-recommendations .slick-prev:not(.slick-arrow)",function(e){
			if(typeof prodData != undefined && prodData != null && prodData.product && !$(this).closest('.plp-cross-sell').length){
				var tempProd = [];
			    var tempInd = 0;			   
			    $('#recommendation-slick-carousel ul.carousel-recommendations li.recommendation-item').each(function(i){   
			    	if($(this).attr('aria-hidden') == "false"){
			    		tempInd = $(this).attr('data-slick-index');
			    		
			    		prodData.product[tempInd].price = parseFloat($(this).find(".product-pricing").find(".price-sales").attr("content"));
			    		
			    		tempProd.push({
							"listType" : "Einstein",
							"list": `${"Einstein"} > ${getPageName()}`,
							"listName": getPageName(),
							"position": prodData.product[tempInd].position,
							"id": prodData.product[tempInd].id,
							"productVariantID": prodData.product[tempInd].productVariantID,
							"category": prodData.product[tempInd].category,
							"price": prodData.product[tempInd].price,
							"name": prodData.product[tempInd].name,
							"brand": getProductBrand(),
							"quantity": prodData.product[tempInd].quantity,
							"size": prodData.product[tempInd].size,
							"subCategory" : prodData.product[tempInd].subCategory,
							"subSubCategory" : prodData.product[tempInd].subSubCategory,
							"productAutoReplen": prodData.product[tempInd].productAutoReplen,
							"productOutOfStock": prodData.product[tempInd].productOutOfStock,
							"productColor": prodData.product[tempInd].color,
							"productType": prodData.product[tempInd].productType,
							"productNumReviews": prodData.product[tempInd].prodNumReviews,
							"productStarRating": prodData.product[tempInd].prodStarRating
						});
			    	}
			    		  
			    });
			    
				pushToDataLayer({
		    				"currencyCode": window.User.currencyCode,
		    				"eeAction": "eeListView",
		    				"event" : "eeListView",
		    				"pageCategory": pageInfo.pageCategory,
		    				"products": tempProd });
            }
		})
		
		.on("click",".cross-sell #recommendation-slick-carousel .carousel-recommendations .slick-next",function(e){
			
			if(typeof prodData != undefined && prodData != null){
		    	var array =  new Array();
		    	var listholder =  new Array();
		    	$( ".recommendation-item" ).each(function( index ) {
		    	  if(index>2 && $(this).hasClass("slick-active")){
		    		array.push(index-3);
		    	  }
		    	});
		    	for(var i=0;i<prodData.product.length;i++){
		    		for(var a=0;a<array.length;a++){
		    			if(i==array[a]){
		    				listholder.push(prodData.product[i]);
		    			}
		    		}
		    	}
		    	pushToDataLayer({
		    				"currencyCode": window.User.currencyCode,
		    				"eeAction": "eeListView",
		    				"event" : "eeListView",
		    				"pageCategory": pageInfo.pageCategory,
		    				"products":listholder});
			}
		})
		
		.on("click",".cross-sell #recommendation-slick-carousel .recommendation-slick-carousel .slick-prev",function(e){
			
			if(typeof prodData != undefined && prodData != null){
		    	var array =  new Array();
		    	var listholder =  new Array();
		    	$( ".recommendation-item" ).each(function( index ) {
		    	  if(index>2 && $(this).hasClass("slick-active")){
		    		array.push(index-3);
		    	  }
		    	});
		    	for(var i=0;i<prodData.product.length;i++){
		    		for(var a=0;a<array.length;a++){
		    			if(i==array[a]){
		    				listholder.push(prodData.product[i]);
		    			}
		    		}
		    	}
		    	pushToDataLayer({
		    				"currencyCode": window.User.currencyCode,
		    				"eeAction": "eeListView",
		    				"event" : "eeListView",
		    				"pageCategory": pageInfo.pageCategory,
		    				"products":listholder});
			}
		})
		
		.on('afterChange', '#recommendation-slick-carousel .carousel-recommendations', function(event, slick, currentSlide) {
			if(typeof prodData != undefined && prodData != null && prodData.product && isMobile()){
			var tempProd = [];
		    var tempInd = 0;
		   
		    $('#recommendation-slick-carousel ul.carousel-recommendations li.recommendation-item').each(function(i){   
		    	if($(this).attr('aria-hidden') == "false"){
		    		tempInd = $(this).attr('data-slick-index');
		    		
		    		prodData.product[tempInd].price = parseFloat($(this).find(".product-pricing").find(".price-sales").attr("content"));
		    		
		    		tempProd.push({
						"listType" : prodData.product[tempInd].listType,
						"listName": prodData.product[tempInd].listName,
						"position": prodData.product[tempInd].position,
						"id": prodData.product[tempInd].id,
						"productVariantID": prodData.product[tempInd].productVariantID,
						"category": prodData.product[tempInd].category,
						"price": prodData.product[tempInd].price,
						"name": prodData.product[tempInd].name,
						"brand": getProductBrand(),
						"quantity": prodData.product[tempInd].quantity,
						"size": prodData.product[tempInd].size,
						"subCategory" : prodData.product[tempInd].subCategory,
						"subSubCategory" : prodData.product[tempInd].subSubCategory,
						"productAutoReplen": prodData.product[tempInd].productAutoReplen,
						"productOutOfStock": prodData.product[tempInd].productOutOfStock,
						"productColor": prodData.product[tempInd].color,
						"productType": prodData.product[tempInd].productType,
						"productNumReviews": prodData.product[tempInd].prodNumReviews,
						"productStarRating": prodData.product[tempInd].prodStarRating
					});
		    	}
		    		  
		    });
		    
			pushToDataLayer({
	    				"currencyCode": window.User.currencyCode,
	    				"eeAction": "eeListView",
	    				"event" : "eeListView",
	    				"pageCategory": pageInfo.pageCategory,
	    				"products": tempProd });
        }})
        
		.on("afterChange",".cross-sell #recommendation-slick-carousel .carousel-recommendations",function(e){
			
			if(typeof prodData != undefined && prodData != null && isMobile()){
		    	var array =  new Array();
		    	var listholder =  new Array();
		    	$( ".recommendation-item" ).each(function( index ) {
		    	  if(index>2 && $(this).hasClass("slick-active")){
		    		array.push(index-3);
		    	  }
		    	});
		    	for(var i=0;i<prodData.product.length;i++){
		    		for(var a=0;a<array.length;a++){
		    			if(i==array[a]){
		    				listholder.push(prodData.product[i]);
		    			}
		    		}
		    	}
		    	pushToDataLayer({
		    				"currencyCode": window.User.currencyCode,
		    				"eeAction": "eeListView",
		    				"event" : "eeListView",
		    				"pageCategory": pageInfo.pageCategory,
		    				"products":listholder});
			}
		})
		
		// pdp fire when variation was change
		.on("gtvariationchange", function (e) {
			if($(".regimenzone").find(".regimen-container").length > 0){
				return;
			}
			if(pageInfo.pageCategory == "Product Page") {
				pushToDataLayer({
					"eeAction": "eeProductDetail",
	                "event" : "eeProductDetail",
	                "pageCategory": "Product Page",
	                'products': [{
	                "listType" : sessionStorage.getItem('listType'),
	                "listName" : sessionStorage.getItem('listName'),
	                "id": pdpdata.variant ? pdpdata.masterID : pdpdata.ID,
	                "productVariantID": pdpdata.variant ? pdpdata.ID : pdpdata.master ? pdpdata.defalutvariant : "",
	                "category":pdpdata.catid,
	                "price": pdpdata.pricing.sale ?  pdpdata.pricing.sale : pdpdata.pricing.minprice,
	                "name": pdpdata.name,
	                "brand":pdpdata.brand,
	                "quantity":pdpdata.quantity,
	                "size": pdpdata.size,
	                "currencyCode": window.User.currencyCode,
	                "subCategory" : pdpdata.subcategory,
	                "subSubCategory" : pdpdata.subsubcategory,
	                "productAutoReplen": pdpdata.productautoreplenish,
	                "productOutOfStock": pdpdata.productOutOfStock,
	                "productColor": pdpdata.productColor,
	                "productType": "Product",
	                "productNumReviews": pdpdata.prodNumReviews,
	                "productStarRating": pdpdata.prodStarRating}]
				})
			}

		})
		.on('contactusformsubmission', function (e) {//contact us form submission
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Contact Customer Service",
					"siteLocation": "Contact us page",
					"pageCategory": pageInfo.pageCategory,
					"pageSubCategory":pageInfo.pageSubCategory
				});
		})

		// productInteraction fire when regimen drop down value change
		.on("change",".regimenzone .product-tile  .dropdown-wrapper .variant-dropdown .variation-select",function(e){	

			var $gtmProductTile = $(this).parents(".product-tile").find('.gtm-product-tile');
			var tileVariantData = $gtmProductTile.data('value');
				pushToDataLayer({
					"event": "productInteraction",
					"productCategory": tileVariantData.subcategory,
					"productSubCategory": tileVariantData.subsubcategory,
					"productName": tileVariantData.name,
					"pageCategory": pageInfo.pageCategory,
					"productId": tileVariantData.ID,
					"interactionType": 'drop-down choice change'
		
				})
		})
		// click order History Track Shipment
		.on("click",".tracking-ship",	function (e) {
			pushToDataLayer({
				"event": "followOrder", 
				"pageCategory": pageInfo.pageCategory, 
				"pageSubCategory": pageInfo.pageSubCategory
			});
		})
		//campaign button/href click
		.on("click",".campaign-form-wrapper .campaign-button",function(){
			let butType = $(this).attr('type');
			butType = butType != undefined ? butType.toLowerCase() : '';
			
			pushToDataLayer({
				"event": "gatedSubscription",
				"siteLocation": pageInfo.pageCategory,
				"choice": butType == 'submit' ? 'yes' : 'no', 
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory
			})
		})
		//click Login pop-up - Checkout
		.on("click", ".sign-into-link#login_only", function (e){
			pushToDataLayer({
				"event": "checkoutLogin",
				"page": '/'+window.User.userCountryFromSession+'/checkout/login',
				"pageCategory": 'Checkout',
				"pageSubCategory": 'Login'
			});
		})
		//click Cart checkout button
		.on("click", ".cart-checkout-button", function (e){
			pushToDataLayer({
				"event": "continueCheckout"
			});
		})

		//click cart checkout button 
		.on("click", ".cart-checkout-button", function (e){
			pushToDataLayer({
				"event": "eeCheckoutOption",
				'checkoutStep' : '1',
  				'checkoutOption' : "classic checkout"
			});
		})
		//click narspro step 3 
		.on("submit", "#nars-pro-signup-form", function (e){
				pushToDataLayer({
					"event": "proSubscription",
					"proType":  window.narsProJson.proType,
					"proFrequency": window.narsProJson.proFrequency,
					"pageCategory": pageInfo.pageCategory
				});			
		})//click apple pay button 
		.on("click", ".adyen-checkout__applepay__button", function (e){			
			pushToDataLayer({
				"event": "eeCheckoutOption",
				"checkoutStep": "1",
				"checkoutOption": "applepay"
			}); 
		})//click paypal express button
		.on("click", ".button-cart-checkout.paypal-button", function (e){			
			pushToDataLayer({
				"event": "eeCheckoutOption",
				"checkoutStep": "1",
				"checkoutOption": "paypal Cart"
			});	
		})
		//Click Fast checkout button of Applepay on Cart page
		.on("click", ".adyen-checkout__applepay__button", function (e){
			pushToDataLayer({
				"event": "checkoutType",
				"fastCheckoutType": "Applepay"
			});
		}) 
		//Click Fast checkout button of Paypal on Cart page
		.on("click", ".button-cart-checkout.paypal-button", function (e){			
			pushToDataLayer({
				"event": "checkoutType",
				"fastCheckoutType": "Paypal"
			})
		})

	.on('click',".btn-flat-black.back-to-top", function (e) {//back to top	
		pushToDataLayer({
			"event": "stickyNavigationTop",			
			"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
			"pageSubCategory": ''
		});
	}).on("click",".shader-finder-cta",function(){ //find ur shade tracking
		if($(this).parents().hasClass('immersive-experience')) {
			pushToDataLayer({
				"event": "pdp_overlay_interaction",
				"productCategory": productCache.category,
				"productSubCategory": productCache.subcategory,
				"productSubSubCategory": productCache.subsubcategory,
				"pageSubCategory": "PDP Overlay",
				"productName": productCache.name,
				"pageCategory": "Explicit Experience",
				"productId": getProductID(),
				"interactionType" : "Try it on"
			})
		} else {
			let interactionType;
			if($(this).hasClass('matchmaker')) {
				interactionType = "click_matchmaker";
			} else {
				interactionType = "click_vto";
			}
			pushToDataLayer({
				"event": "productInteraction",
				"interactionType" : interactionType,
				"productCategory": productCache.category,
				"productSubCategory": productCache.subcategory,
				"productName": productCache.name,
				"id": $("#pdpMain").data("masterid"),
				"productVariantID": getProductID(),
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory
			})
		}

	}).on('click', ".content-link-container a, .mobile-menu-bottom a", function(){//top menu 
		if($(this).attr('data-gtm-name') != undefined){
			sessionStorage.setItem("navlink",$(this).attr('data-gtm-name').trim());
			sessionStorage.setItem("menuloc","topmenu");
		}		
	}).on("click","#login", function(){
		if(window.User.isRegistered && !sessionStorage.getItem('uservalidation')){
			pushToDataLayer({
					"event": "accountLogin",
					'userId':window.User.customerNo,
					'accountType':window.User.isExternallyAuthenticated,
					'pageSubCategory':pageInfo.pageSubCategory,
					'pageCategory': pageInfo.pageCategory,
					'loginLocation': 'Logged in outside checkout',
					'socialType': localStorage['socialLoginType'] ? localStorage['socialLoginType'] : null
				});
			sessionStorage.setItem('uservalidation',true);
			if(localStorage['socialLoginType'] != undefined){
				localStorage.removeItem('socialLoginType'); 
			}
		}
	}).on("click",".tokywoky-widget .tokywoky-btn", function(){
		// tokywoky
			pushToDataLayer({
					"event": "create_my_own_routine_click",
					'pageSubCategory':pageInfo.pageSubCategory,
					'pageCategory': pageInfo.pageCategory,
				});
	}) // Bambuser 
	.on('click',".bambuser-replay-wrapper .bambuser-thumbnail, .bambuser-replay-wrapper .bambuser-description", function (e) {	
		pushToDataLayer({
			"event": "productInteraction",
			"productName": getProductName(),
			"pageCategory": pageInfo.pageCategory,
			"productId": productCache.variant ? productCache.masterID : productCache.ID,
			"interactionType" : "bambuser_replay_click"
		})
	}).on("click",".promo-redirection", function(){
		var _this = $(".cart-promo-header");
		pushToDataLayer({
			'event' : 'banner_interaction',
			'banner_position' : 'top',
			'banner_click' : 'redirect',
			'banner_name' : _this.attr("data-banner_name")
		})
	}).on('click', '.copy-promotion-code, .promotion-code-to-copy', function (e) {
		var _this = $(".cart-promo-header");
		pushToDataLayer({
			'event' : 'banner_interaction',
			'banner_position' : 'top',
			'banner_click' : 'copy',
			'banner_name' : _this.attr("data-banner_name"),
			'promotion_code' : $(this).attr('data-promotion_code')
		});
	})
	//paypal consent sheet
	.on('change','.cart-paypal-specific-popin input[type="checkbox"]', function (e) {		
		const isGpay = $('#googlepay-container').find('div').length > 0;
		const isPayPal = $('#paypal-container').find('div').length > 0;
		let interactionPayment;

		// Determine the interactionPayment based on the payment method
		if (isGpay) {
		interactionPayment = $(this).hasClass('newsletteroptinconsent') 
			? 'popin_googlepay_tick_newsletter' 
			: 'popin_googlepay_tick_conditions';
		} else if (isPayPal) {
		interactionPayment = $(this).hasClass('newsletteroptinconsent') 
			? 'popin_paypal_tick_newsletter' 
			: 'popin_paypal_tick_conditions';
		}


		if(this.checked){
			pushToDataLayer({
				'event' : isGpay ? 'popin_googlepay_conditions_interaction' : 'popin_paypal_conditions_interaction',
				'interactionType' : interactionPayment,
			});
        }		
	})

	.on('click','.main-nav .no-sub-menu', function () {
		const listName = $(this).find('a').text().trim();
		pushToDataLayer({
			'event' : 'menu_interaction',
  			'list_name' : listName
		})
	})

	.on('click', '.category-header', function(){
		const listNameCategory = $(this).closest('.has-sub-menu').find(".level-1-link").text().trim();
		const listCategory = $(this).find('h2').text().trim();
		pushToDataLayer({
			'event' : 'menu_interaction',
			'list_name' : listNameCategory,
			'list_category' : listCategory,
		})
	})
	
	//header-account-icon-click-event
	.on('click', '.sign-in-wrapper .myaccount', function () {
		pushToDataLayer({
			'event': 'header_interaction',
			'header_click': 'Account'
		});
	})
	
	//header-basket-icon-click-event
	.on('click', '.mini-cart-link', function () {
		pushToDataLayer({
			'event': 'header_interaction',
			'header_click': 'Basket'
		});
	})

	//header-menu-icon-click-event
	.on('click', '.icon-hamburger', function () {
		pushToDataLayer({
			'event': 'header_interaction',
			'header_click': 'Menu'
		});
	})
	
	//header-language-icon-click-event
	.on('click', '.button-switch-wrapper .utility-link', function () {
		pushToDataLayer({
			'event': 'header_interaction',
			'header_click': 'Language'
		});
	})
	
	//new-header-offers-text-click-event
	.on('click', '.offers-link a', function () {
		pushToDataLayer({
			'event': 'header_interaction',
			'header_click' : 'Offers'
		});
	})

	.on('click','.thirdlevelmenu .catalog-link a',function () {
		const listSubCategory = $(this).text().trim();
		const listCategory = $(this).closest('.level-2-link').find('h2').text().trim();
		const listNameCategory = $(this).closest('.has-sub-menu').find('.level-1-link').text().trim();
		pushToDataLayer({
			'event' : 'menu_interaction',
			'list_name' : listNameCategory,
			'list_category' : listCategory,
			'list_subcategory' : listSubCategory
		})
	})

	//PLP image interactions for desktop
	.on('click','.pt_product-search-result .product-tile-wrapper .slick-next', function() {
		if($(window).width() >= 767) {
			pushToDataLayer({
				"event": "PLPInteractions",
				"productName": $(this).closest('.product-tile-wrapper').find('.product-name').text().trim(),
				"productId": $(this).closest('.product-tile').attr('data-itemid'),
				"interactionType":  "Image Change",
				"imageSelection": $(this).closest('.product-tile').find('.slick-active').index()+1,
				"sumImage": $(this).closest('.product-tile').find('.thumb-link').length
			});
		}
	})
	//PLP image interactions for mobile on swipe forward
	.on('swipe','.pt_product-search-result .product-slick-track', function(event, slick, direction) {
		if($(window).width() <= 767 && !window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
			if(direction == 'left') {
				pushToDataLayer({
					"event": "PLPInteractions",
					"productName": $(this).closest('.product-tile-wrapper').find('.product-name').text().trim(),
					"productId": $(this).closest('.product-tile').attr('data-itemid'),
					"interactionType":  "Image Change",
					"imageSelection": $(this).closest('.product-tile').find('.slick-active').index()+1,
					"sumImage": $(this).closest('.product-tile').find('.thumb-link').length
				});
			}
		}
	})
	
	.on('click', '.product-compare-wrapper  .thumb-link, .product-compare-wrapper .bv_stars_button_container, .product-compare-wrapper .bv_sub_container, .product-compare-wrapper .product-compare-view-btn', function (e) {
		const $this = $(this);
		const $compareItem = $this.closest('.product-compare-item');
		const index = $compareItem.index();
		const tileVariantDataArr = window.compareProdData.product;
		const productsList = [];
		let count = 1;

		// push only the clicked product
		if (Array.isArray(tileVariantDataArr) && tileVariantDataArr.length > index) {
			const tileVariantData = tileVariantDataArr[index];
			const productdetails = {};
			productdetails.listType = "Product Compare";
			productdetails.listName = "Product Page";
			productdetails.position = count++;
			productdetails.brand = tileVariantData.brand;
			productdetails.category = tileVariantData.category;
			productdetails.categoryID = tileVariantData.categoryID;
			productdetails.collectionName = tileVariantData.collectionName;
			productdetails.color = tileVariantData.color;
			productdetails.id = tileVariantData.id;
			productdetails.name = tileVariantData.name;
			productdetails.price = tileVariantData.price;
			productdetails.productColor = tileVariantData.productColor;
			productdetails.productNumReviews = tileVariantData.productNumReviews;
			productdetails.productOutOfStock = tileVariantData.productOutOfStock;
			productdetails.productStarRating = tileVariantData.productStarRating;
			productdetails.productType = tileVariantData.productType;
			productdetails.productVariantID = tileVariantData.productVariantID;
			productdetails.size = tileVariantData.size;
			productdetails.subCategory = tileVariantData.subCategory;
			productdetails.subCategoryID = tileVariantData.subCategoryID;
			productdetails.subSubCategory = tileVariantData.subSubCategory;
			productdetails.subSubCategoryID = tileVariantData.subSubCategoryID;
			productdetails.variant = tileVariantData.variant;
			productsList.push(productdetails);
		}

		pushToDataLayer({
			"currencyCode": currencyCode,
			"event": "eeListClick",
			"pageCategory": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"products": productsList
		});
	})
	.on("click", ".dialog-suggestion", function () {
		//pdp ai dialog on question click
			pushToDataLayer({
				"event": "dialog_click_questions"
			});
		})

		//narspro onload events
		window.onload = function() {			
			switch(window.Resources.PAGE_CATEGORY) {
				case "search-showcontent": case "search-show" :
					if ($(".narsprolanding-content")[0]){
						
						pushToDataLayer({
							  "proFrequency": "",
							  "event": "proTypeStep",
							  "proType": "",
							  "proTypeStep": window.narsProJson.proTypeStep,
							  "pageCategory": pageInfo.pageCategory
							  })
							  
							  //onclick new/renew
							  $(document).on("click", "a", function(){
								  
							   pushToDataLayer({
									  "proFrequency": window.narsProJson.proFrequency,
									  "event": "proTypeStep",
									  "proType": this.id,
									  "proTypeStep": window.narsProJson.proTypeStep,
									  "pageCategory": pageInfo.pageCategory
									  })
							}); 
					}
					
				break;
			  case "login-narprologin": case "account-narsproregister" :
				  var url_string = window.location.href
				  var url = new URL(url_string);
				  var proType = url.searchParams.get("narsprotype");
				  var isRenew = url.searchParams.get("renew");
				  if (isRenew) {
					  localStorage.setItem('narsProType', '');
				  }
				  proType = proType ? proType : localStorage.getItem('narsProType');
				  proType = proType ? proType : '';				  
				  proType = proType.charAt(0).toUpperCase() + proType.slice(1);
				  localStorage.setItem('narsProType', proType);
				  localStorage.setItem('narsProStepType', window.narsProJson.proTypeStep);				  
				  
				  pushToDataLayer({
					  "proFrequency": window.narsProJson.proFrequency,
					  "event": "proTypeStep",
					  "proType": proType,
					  "proTypeStep": window.narsProJson.proTypeStep ,
					  "pageCategory": pageInfo.pageCategory
					  })
			    break;
			  case "narspro-apprenticesignup":
				  localStorage.setItem('narsProType', window.narsProJson.proType);
				  localStorage.setItem('narsProStepType', window.narsProJson.proTypeStep);
				  
				  pushToDataLayer({
					  "proFrequency": window.narsProJson.proFrequency,
					  "event": "proTypeStep",
					  "proType":window.narsProJson.proType,
					  "proTypeStep": window.narsProJson.proTypeStep,
					  "pageCategory": pageInfo.pageCategory
					  })
			    break;
			  case "narspro-industrysignup":
				  localStorage.setItem('narsProType', window.narsProJson.proType);
				  localStorage.setItem('narsProStepType', window.narsProJson.proTypeStep);
				  
				  pushToDataLayer({
					  "proFrequency": window.narsProJson.proFrequency,
					  "event": "proTypeStep",
					  "proType":window.narsProJson.proType,
					  "proTypeStep": window.narsProJson.proTypeStep,
					  "pageCategory": pageInfo.pageCategory
					  })
			    break;
			  case "narspro-artistsignup":
				  localStorage.setItem('narsProType', window.narsProJson.proType);
				  localStorage.setItem('narsProStepType', window.narsProJson.proTypeStep);
				  
				  pushToDataLayer({
					  "proFrequency": window.narsProJson.proFrequency,
					  "event": "proTypeStep",
					  "proType":window.narsProJson.proType,
					  "proTypeStep": window.narsProJson.proTypeStep,
					  "pageCategory": pageInfo.pageCategory
					  })
			    break;
			  case "narspro-submit":
				  localStorage.setItem('narsProStepType', window.narsProJson.proType);
				  pushToDataLayer({
					  "proFrequency": window.narsProJson.proFrequency,
					  "event": "proTypeStep",
					  "proType": localStorage.getItem('narsProType'),
					  "proTypeStep": window.narsProJson.proTypeStep,
					  "pageCategory": pageInfo.pageCategory
					  })
			    break;
			  case "narspro-show":
				  narsProStepOne('', "Step1");
				  break;
			  case "narspro-renew":
				  narsProStepOne('',"Step2");
				  break;
			  default:
			    // code block
			}		 
		};
	$(".cross-section").on("click", function() {
		pushToDataLayer({
			"event": "list_crossnav_interaction",
			"list_subcategory":  $(this).find('.cross-tag-name').html().trim()
		});
	});
}

function minicrosssellPDPonInit($minicrossSellRecommendations) {
	$minicrossSellRecommendations.on('init', function () {
		util.getTrulyVisibleSlides($minicrossSellRecommendations).then(() => {
			pdpCrosssellList($minicrossSellRecommendations);
		});
	});
}

function gymSharkCrossSellafterInit($gymsharkcrossSellRecommendations) {
	gymSharkCrosssellList($gymsharkcrossSellRecommendations);
	$gymsharkcrossSellRecommendations.on('click',".thumb-link, .product-link", function () {	
		pushToDataLayer({
			"event": "eeListClick",
			"pageCategory": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"products": crosssellProducts($(this).closest('.recommendation-item'), "Gymshark", "Minicart")
		});
	});
}

// menu cross sell redirection
function menuCrossSellClick($menucrossSellRecommendations) {
	$menucrossSellRecommendations.on('click',".product-tile-wrapper", function () {
		pushToDataLayer({
			"event": "eeListClick",
			"pageCategory": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"products": crosssellProducts($(this).closest('.slick-slide'), "Einstein", "Menu")
		});
	});
}

// menu cross sell view
function menuCrosssellList($container) {
	pushToDataLayer({
		"currencyCode": currencyCode,
		"eeAction": "eeListView",
		"event": "eeListView",
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		"products": crosssellProducts($container.find('.slick-slide'), "Einstein", "Menu")
	});
}

function minicrosssellPDPafterInit($minicrossSellRecommendations) {
	$minicrossSellRecommendations.on('afterChange', function () {
		util.getTrulyVisibleSlides($minicrossSellRecommendations).then(() => {
			pdpCrosssellList($minicrossSellRecommendations);
		});
	});

	$(window).on('resize', () => {
		setTimeout(() => {
			util.getTrulyVisibleSlides($minicrossSellRecommendations).then(() => {
				pdpCrosssellList($minicrossSellRecommendations);
			});
		}, 100);
	});
	
	$minicrossSellRecommendations.on('click',".product-link, .thumb-link", function () {
		pushToDataLayer({
			"event": "eeListClick",
			"pageCategory": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"products": crosssellProducts($(this).closest('.slick-slide'), "Einstein", "Top Product Page")
		});
	});
}

function pdpCrosssellList($container) {
	pushToDataLayer({
		"currencyCode": currencyCode,
		"eeAction": "eeListView",
		"event": "eeListView",
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		"products": crosssellProducts($container.find('.slick-slide.truly-visible'), "Einstein", "Top Product Page")
	});
}

function gymSharkCrosssellList($container) {
	const isCrossSell = $('.crosssell-recommendation-modal');
	if ( isCrossSell.length && isCrossSell.attr('data-crosssellListFired')) {
		return;
	}
	isCrossSell.attr('data-crosssellListFired', true);
	pushToDataLayer({
		"currencyCode": currencyCode,
		"eeAction": "eeListView",
		"event": "eeListView",
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		"products": crosssellProducts($container.find('.recommendation-item'), "Gymshark", "Minicart")
	});
}

function crosssellProducts($productListItems, $productListType, $productListName) {
	let productsList = [];
	let count = 1;
	let prodIndex = 1;
	let addTocartAct = $productListItems.find('.product-tile').length > 1 ? false : true;
	$productListItems.find('.product-tile').each(function () {
		let product = {};
		const tileVariantData = $(this).find('.gtm-product-tile').data('value');	
		if (!tileVariantData) return;

		if(addTocartAct){
			prodIndex = $(this).closest('.slick-slide').data('slick-index') ? $(this).closest('.slick-slide').data('slick-index') + 1 : $(this).closest('.recommendation-item').data('position') ;
			prodIndex = prodIndex ? prodIndex : count;		
		}else{
			prodIndex = count++;
		}
		product.listType = $productListType;
		product.listName = $productListName;
		product.position = prodIndex;
		product.id = tileVariantData.masterID ? tileVariantData.masterID : tileVariantData.ID;
		product.productVariantID = tileVariantData.ID;
		product.category = tileVariantData.catid;
		product.price = tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice;
		product.name = tileVariantData.name;
		product.brand = getProductBrand();
		product.size = tileVariantData.size;
		product.subCategory = tileVariantData.subcategory;
		product.subSubCategory = tileVariantData.subsubcategory;
		product.productAutoReplen = tileVariantData.productautoreplenish;
		product.productOutOfStock = tileVariantData.productOutOfStock;
		product.productColor = tileVariantData.productColor;
		product.productType = "Product";
		product.collectionName = tileVariantData.customBrand;
		product.productBundle = tileVariantData.bundle;
		productsList.push(product);
	})
	return productsList;
}

$("#thumbnails").off('mouseover', '.productthumbnail.product-image-thumbnail, .productthumbnail.video-thumbnail-image');
$("#thumbnails").off().on('mouseenter', '.productthumbnail.product-image-thumbnail, .productthumbnail.video-thumbnail-image', function (e) {

	pushToDataLayer({
		"event": "productInteraction",
		"productCategory": getProductCategory().split('\n').shift(),
		"productSubCategory": getProductsubCategory().split('\n').shift(),
		"productName": $(".product-title .product-name").text(),
		"pageCategory": pageInfo.pageCategory,
		"productId": productCache.variant ? productCache.masterID : productCache.ID,
		"productVariantID": getProductID(),
		"interactionType" : "Change Image"
	})
});

//Load Product Detail datalayer on quickshop
$('.tiles-container .product-image .quickview.minidetails').on('click', function (e) {		
	var pid = $(this).parents(".product-tile").data("itemid");
	var clickProduct = {};
	var tempProdData = {};

	if(prodholder[0].length){
		tempProdData = prodholder[0];
		for(var i=0;i<tempProdData.length;i++){
			if(tempProdData[i].productVariantID == pid || tempProdData[i].id == pid){
				clickProduct = tempProdData[i];
				break;
			}
		}
	}

	if(clickProduct.length == undefined){
		for(var i=0;i<prodholder.length;i++){
			if(prodholder[i].productVariantID == pid || prodholder[i].id == pid){
				clickProduct = prodholder[i];
				break;
			}
		}
	}			
	pushToDataLayer({
		"eeAction": 'eeListClick',
		"event" : 'eeListClick',
		"pageCategory": pageInfo.pageCategory,
		'products': [{
			"listType" : clickProduct.listType,
			"listName" : clickProduct.listName,
			"id": clickProduct.id,
			"productVariantID": clickProduct.productVariantID,
			"category":clickProduct.category,
			"price": clickProduct.price,
			"name": clickProduct.name,
			"brand":clickProduct.brand,
			"quantity":clickProduct.quantity,
			"size": clickProduct.size,
			"subCategory" : clickProduct.subCategory,
			"subSubCategory" : clickProduct.subSubCategory,
			"productAutoReplen": clickProduct.productAutoReplen,
			"productOutOfStock": clickProduct.productOutOfStock,
			"productColor": clickProduct.productColor,
			"productType": "Product",
			"productNumReviews": clickProduct.prodNumReviews,
			"productStarRating": clickProduct.prodStarRating
		}]
	})



})


//click nars pro step 1
function narsProStepOne(proType,proTypeStep){
	localStorage.setItem('narsProType', proType);
	localStorage.setItem('narsProStepType', proTypeStep);
	
		pushToDataLayer({
			 "proFrequency": window.narsProJson.proFrequency,
			 "event": "proTypeStep",
			 "proType": proType,
			 "proTypeStep": window.narsProJson.proTypeStep ? window.narsProJson.proTypeStep : proTypeStep,
			 "pageCategory": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory
		});
}

function paypalExpressDatalayer() {
	pushToDataLayer({
		'event' : 'popin_paypal_conditions_interaction',
		'interactionType' : 'popin_paypal_click_paypal'
	});
}

function googlePayTracking() {
	pushToDataLayer({
		'event' : 'popin_googlepay_conditions_interaction',
		'interactionType' : 'popin_googlepay_click_googlepay'
	});
}

function removeProductFromCart(index, qty){
	var pproductOrderType  = "";
	if (basketConfirmation.productLineItems[index-1].productAutoReplen == "No"){
		pproductOrderType= "Regular";					
	}
	else {
		pproductOrderType= "Replenishment";
	}
	
	
	var prod = basketConfirmation.productLineItems[index-1].id;
	
	
	pushToDataLayer({
		"currencyCode": currencyCode,
		"event": "removeFromCart",
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory" : pageInfo.pageSubCategory,
		'siteLocation': 'Cart page',
		'products': [{
		"id": basketConfirmation.productLineItems[index-1].id,
		"category": basketConfirmation.productLineItems[index-1].category,
		"price": basketConfirmation.productLineItems[index-1].price,
		"name": basketConfirmation.productLineItems[index-1].name,
		"brand": getProductBrand(),
		"quantity": qty,
		"size": basketConfirmation.productLineItems[index-1].size,
		"subCategory" : basketConfirmation.productLineItems[index-1].subCategory,
		"subSubCategory" :basketConfirmation.productLineItems[index-1].subSubCategory,
		"productAutoReplen": basketConfirmation.productLineItems[index-1].productAutoReplen,
		"productOrderType": pproductOrderType,
		"productOutOfStock":basketConfirmation.productLineItems[index-1].productAutoReplen.productOutOfStock,
		"productColor":  basketConfirmation.productLineItems[index-1].productColor,
		"productVariantID": basketConfirmation.productLineItems[index-1].productVariantID,
		"productType": basketConfirmation.productLineItems[index-1].productType}]

	});
}

function populateSearchSuggestion() {
	
	//push data after user stops for 2secs, search suggestion box
	
	$('.product-search-suggestion').on("click", function() {
		var index = $(this).data('index');
		if(index >= 0){
			var nextPage = $(this).find('a.product-link').attr('href');
			
			pushToDataLayer({
				"event": "eeListClick",
				"nextPage": nextPage,
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory,
				"filterChoice" : getActiveSortingRule(),
				"dropDown" : getRefinementsFromURL(),
				"list" : searchProductData.product[index].listType +' > '+searchProductData.product[index].listName,
				'products': [searchProductData.product[index]]
			})
			sessionStorage.setItem('listType',searchProductData.product[index].listType);
			sessionStorage.setItem('listName',searchProductData.product[index].listName);
		}
	})
	
	
}

/**
 * google address click data layer
 * @returns
 */
function googleAddressTracking(){
	pushToDataLayer({	
		"event": "searchInteractions",
		"pageCategory": pageInfo.pageCategory,
		"interactionType" : "GoogleAutocomplete used",
	});
}

/*
 * datalayer for Reinsurance Elements
 */
function reinsuranceElements(data) {
	var reinsuranceChoice = '';
	
	switch(data) {
	  case 'shipping-reinsurance-popup':
		  reinsuranceChoice = 'Shipping';
	    break;
	  case 'return-refund-reinsurance-popup':
		  reinsuranceChoice = 'Returns';
	    break;
	  case 'order-payment-reinsurance-popup':
		  reinsuranceChoice = 'Orders';
	    break;
	  case 'discount-codes-reinsurance-popup':
		  reinsuranceChoice = 'Offers';
	    break;
	}
	
	pushToDataLayer({
		"page":pageInfo.pageCategory,
		"event": "reinsuranceElements",
		"reinsuranceChoice" : reinsuranceChoice,
		"pageSubCategory": pageInfo.pageSubCategory,
		"pageCategory": pageInfo.pageCategory				
	});	
}

//header-signin-icon-click-event
function trackSignInDrawerOpen() {
    pushToDataLayer({
        'event': 'account_modal'
    });
}

//clicking CTA from the msg
function trackClickCtaAccountModal(loginLocation) {
	var dataObj = {
        'event': 'click_cta_account_modal'
    };
	if (loginLocation) {
        dataObj.loginLocation = loginLocation;
    }
    pushToDataLayer(dataObj);
}

//clicking CTA on login drawer 
function trackClickCtaPerksAccountModal() {
    pushToDataLayer({
        'event': 'click_cta_perks_account_modal'
    });
}

/*
*  To track Social login type on loggedinn
*/ 
function socialLoginEvent(socialId) {
	socialId = socialId.toLowerCase();
	
	var socialType = "Google";
	
	if(socialId.indexOf('apple') > -1){
		socialType = "Apple";
	}
	
	localStorage['socialLoginType'] = socialType;
}

/*
 * datalayer for Search Overlay
 */

function searchOverlayShow () {
	pushToDataLayer({
		event: 'virtualPageview',
		navigationLocationClicked: 'search overlay',
		websiteCountry: pageInfo.websiteCountry,
		language: pageInfo.language,
		pageSubCategory: pageInfo.pageSubCategory,
		pageCategory: pageInfo.pageCategory
	});
}

function searchProductTile (event) {

	var $gtmProductTile = $(event).parents(".product-tile-outer").find('.gtm-search-tile');

	var tileVariantData = $gtmProductTile.data('value');

	pushToDataLayer({
		event: 'eeListClick',
		pageCategory: pageInfo.pageCategory,
		products: [
			{
				"id": tileVariantData.id,
				"name": tileVariantData.name,
				"price": tileVariantData.price,
				"category": tileVariantData.category,
				"collectionName": tileVariantData.collectionName,
				"subCategory": tileVariantData.subcategory,
				"subSubCategory": tileVariantData.subsubcategory,
				"productOutOfStock": tileVariantData.productOutOfStock,
				"color" : tileVariantData.productColor,
				"productColor": tileVariantData.productColor,
				"variant": tileVariantData.variant,
				"productAutoReplen": tileVariantData.productautoreplenish,
				"productType": tileVariantData.productType,
				"size": tileVariantData.size,
				"productVariantID": tileVariantData.productVariantID,
				"listType": 'search overlay',
				"listName": tileVariantData.listName,
				"list": 'Search',
				"position": '',
				"quantity": tileVariantData.quantity,
			}
		]
	});
};

function searchCategoryLink (event) {
	let interactionType = '';
	let filterSelection = '';
	const $event = $(event);
	if($event.parents('.category-wrapper').length > 0){
		interactionType = 'Categories';
		// Create a regular expression to match both values
		var CategoryRegex = new RegExp('<strong>' + "|" + '</strong>', "g");
		// Use the `replace()` method to remove the matched values
		var resultString = $event.parent('.item').attr('data-category').replace(CategoryRegex, "");

		filterSelection = resultString;
	} else if($event.parents('.suggestion-wrapper').length > 0){
		interactionType = 'Suggestions';
		filterSelection = $event.html();
	} else if($event.parents('.popular-search-catergory').length > 0 && !$event.parents('.recent-search-cont').length > 0 ){
		interactionType = 'Popular searches'
		filterSelection = $event.parent('.item').attr('data-category');
	} else if($event.parents('.suggestion-header').length > 0){
		interactionType = 'view all'
	}
	else if ($event.parents('.recent-search-cont').length > 0) {
		interactionType = 'historical_searches'
	} 

	pushToDataLayer({
		event: "search_overlay_interaction",
		overlayInteractionType: interactionType,
		filterSelection: filterSelection,
		pageCategory: pageInfo.pageCategory,
		pageSubCategory: pageInfo.pageSubCategory
	})
}

function searchEinstienProductList () {
	var productsList = [];
	var count = 1;
			for(var i = 0; i < searchProductData.product.length; i++) {
				var productlistdata = {
					"id": searchProductData.product[i].id,
					"name": searchProductData.product[i].name,
					"price": searchProductData.product[i].price,
					"category": searchProductData.product[i].category,
					"collectionName": searchProductData.product[i].collectionName,
					"subCategory": searchProductData.product[i].subcategory,
					"subSubCategory": searchProductData.product[i].subsubcategory,
					"productOutOfStock": searchProductData.product[i].productOutOfStock,
					"color" : searchProductData.product[i].productColor,
					"productColor": searchProductData.product[i].productColor,
					"variant": searchProductData.product[i].variant,
					"productAutoReplen": searchProductData.product[i].productAutoReplen,
					"productType": searchProductData.product[i].productType,
					"size": searchProductData.product[i].size,
					"productVariantID": searchProductData.product[i].productVariantID,
					"listType": 'search overlay',
					"listName": searchProductData.product[i].listName,
					"list": 'Search',
					"position": count++,
					"quantity": searchProductData.product[i].quantity,
				}
				productsList.push(productlistdata)
			}

			pushToDataLayer({
				event: "eeListView",
				eeAction: "eeListView",
				pageCategory: pageInfo.pageCategory,
				currencyCode: currencyCode,
				products: productsList
			});
}

/**
 * paypal epress submit event
 */
function paypalExpressSubmitEvent(){
	pushToDataLayer({
		'event' : 'popin_paypal_conditions_interaction',
		'interactionType' : 'popin_paypal_click_paypal'
	});
}
function couponCodeEvent (couponCodeText) {
	if(typeof couponCodeText != 'undefined') {
		couponCodeText = couponCodeText.toUpperCase();
		if($(".gtpromochecker").length > 0 ){
			var couponCodeEle= $('[data-name="'+couponCodeText+'"]');
				pushToDataLayer({
						"productCoupon": couponCodeEle.data("id"),
						"event": "couponSubmission",
						"couponCode" : couponCodeEle.data("name"),
						"pageSubCategory": pageInfo.pageSubCategory,
						"pageCategory": pageInfo.pageCategory
				})
				localStorage['couponvalidation'] = true;
		}
	}	
}
function payPalDataLayerPush(){
	pushToDataLayer({
		"event": "eeCheckoutOption",
		"checkoutStep": "1",
		"checkoutOption": "paypal Cart"
	});
}

function googlePayDataLayerPush() {
	pushToDataLayer({
		"event": "eeCheckoutOption",
		"checkoutStep": "1",
		"checkoutOption": "googlepay Cart"
	});
}
function addToCartDataLayerPush(tileVariantData) {
  pushToDataLayer({
    currencyCode: window.User.currencyCode,
    event: "addToCart",
    pageCategory: pageInfo.pageCategory,
    pageSubCategory: pageInfo.pageSubCategory,
    products: [
      {
        id: tileVariantData.masterID,
        category: tileVariantData.catid,
        price: tileVariantData.pricing.sale
          ? tileVariantData.pricing.sale
          : tileVariantData.pricing.minprice,
        name: tileVariantData.name,
        brand: tileVariantData.brand,
        quantity: tileVariantData.quantity,
        size: tileVariantData.size,
        subCategory: tileVariantData.subcategory,
        subSubCategory: tileVariantData.subsubcategory,
        productAutoReplen: tileVariantData.productautoreplenish,
        productOutOfStock: tileVariantData.productOutOfStock,
        productColor: tileVariantData.productColor,
        productType: tileVariantData.productType,
        collectionName: tileVariantData.customBrand,
        productNumReviews: tileVariantData.productNumReviews,
        productStarRating: tileVariantData.productStarRating,
      },
    ],
  });
}
function payPalCartDataLayerPush(){
	pushToDataLayer({
		"event": "checkoutType",
		"fastCheckoutType": "Paypal"
	});
}
function appleCartDataLayerPush(){
	pushToDataLayer({
		"event": "checkoutType",
		"fastCheckoutType": "Applepay"
	});
}

//add sample to cart-old
function addSelectedSamplesToCart() {
	var _this = $(this);
	var sample_added_name = [];
	var addedSamples = $(document).find('.sample-overlay button[value="selected"]').closest('.product-tile-wrapper');
	var sample_brand;
	var collectionName;
	addedSamples.each(function () {
		var product = {};
		var gtmValue = $(this).find('.gtm-product-tile');
		var tileVariantData = gtmValue.data('value');
		product.name = tileVariantData.name;
		sample_brand = tileVariantData.brand;
		collectionName = tileVariantData.customBrand;
		sample_added_name.push(product);
	});
	var concatenatedString = '';

	for (var i = 0; i < sample_added_name.length; i++) {
		if (sample_added_name[i].name) { // Check if the 'name' property exists
			if (i > 0 && concatenatedString !== '') {
				concatenatedString += ', ';
			}
			concatenatedString += sample_added_name[i].name;
		}
	}
	var sample_name = concatenatedString.trim();
	var sample_number = $(document).find('.sample-overlay button[value="selected"]').length;
	
	pushToDataLayer({
		'event' : 'add_sample_to_cart', 
		'sample_number' : sample_number,
		'sample_name_listing': sample_name,
		'checkoutStep' : '1',
		'pageCategory': pageInfo.pageCategory,
		'pageSubCategory': pageInfo.pageSubCategory,
		'currencyCode': window.Resources.CURRENCY,
		'collectionName': collectionName,
	});
}

//Gift Card Added to Cart
function addBonusProductMinicartDataLayer(pids) {
	let refProd = typeof(basketConfirmation) != 'undefined' ? basketConfirmation.productLineItems : miniCartConfirmation.productLineItems;
	if(pids && pids.length > 0){
		let pidsArr = pids.split(',');
		let finalProd = [];

		for (let i = 0; i < refProd.length; i++) {
			if( (pidsArr.includes(refProd[i].productVariantID) || pidsArr.includes(refProd[i].id)) && refProd[i].productType == 'Bonus Product'){
				finalProd.push(refProd[i]);
			}
		}

		pushToDataLayer({
			'event' : 'add_gwp_to_cart', 
			"addToCartType": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"pageCategory": pageInfo.pageCategory,
			"currencyCode": window.Resources.CURRENCY,
			"product" :finalProd
			});	


	}else{
		//Filter the bonus products based on product type
		let  lineItems = miniCartConfirmation.productLineItems;

		let filteredBonus = lineItems.filter((lineItem) => {
			return lineItem.productType == "Bonus Product";
		});
		//Minicart bonus products structure different for mobile and desktop
		let minicartBonus;
		if(isMobile) {
			minicartBonus = $('.minicart-desktop').find('.mini-cart-bonus').length;
		} else {
			minicartBonus = $('.mini-cart-mobile').find('.mini-cart-bonus').length;
		}
		let index = minicartBonus - 1;
		pushToDataLayer({
			'event' : 'add_gwp_to_cart', 
			"addToCartType": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"pageCategory": pageInfo.pageCategory,
			"currencyCode": window.Resources.CURRENCY,
			"product" : {
				"id": filteredBonus[index].id,
				"category": filteredBonus[index].category,
				"name": filteredBonus[index].name,
				"brand": getProductBrand(),
				"quantity": filteredBonus[index].quantity,
				"size": filteredBonus[index].size,
				"subCategory": filteredBonus[index].subCategory,
				"subSubCategory": filteredBonus[index].subSubCategory,
				"productAutoReplen": filteredBonus[index].productAutoReplen,
				"productOutOfStock": filteredBonus[index].productOutOfStock,
				"productColor": filteredBonus[index].productColor,
				"productType": filteredBonus[index].productType,
				"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
				"productVariantID": filteredBonus[index].productVariantID,
				"collectionName": filteredBonus[index].collectionName
			}		
		});
	}
}
//Gift Card Added to Cart
function addBonusProductDataLayer(pids) {
	let refProd = typeof(basketConfirmation) != 'undefined' ? basketConfirmation.productLineItems : miniCartConfirmation.productLineItems;
	if(pids && pids.length > 0){
		let pidsArr = pids.split(',');
		let finalProd = [];

		for (let i = 0; i < refProd.length; i++) {
			if( (pidsArr.includes(refProd[i].productVariantID) || pidsArr.includes(refProd[i].id)) && refProd[i].productType == 'Bonus Product'){
				finalProd.push(refProd[i]);
			}
		}

		pushToDataLayer({
			'event' : 'add_gwp_to_cart', 
			"addToCartType": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"pageCategory": pageInfo.pageCategory,
			"currencyCode": window.Resources.CURRENCY,
			"product" :finalProd
			});	


	}else{
	
		//Bonus product is added at the end
		let cartLineItem  = $('.cart-row').length;
		let index = cartLineItem - 1;
	
	pushToDataLayer({
		'event' : 'add_gwp_to_cart', 
		"addToCartType": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		"pageCategory": pageInfo.pageCategory,
		"currencyCode": window.Resources.CURRENCY,
		"product" : {
			"id": basketConfirmation.productLineItems[index].id,
			"category": basketConfirmation.productLineItems[index].category,
			"price": basketConfirmation.productLineItems[index].price,
			"name": basketConfirmation.productLineItems[index].name,
			"brand": getProductBrand(),
			"quantity": basketConfirmation.productLineItems[index].quantity,
			"size": basketConfirmation.productLineItems[index].size,
			"subCategory": basketConfirmation.productLineItems[index].subCategory,
			"subSubCategory": basketConfirmation.productLineItems[index].subCategory,
			"productAutoReplen": basketConfirmation.productLineItems[index].productAutoReplen,
			"productOutOfStock": basketConfirmation.productLineItems[index].productOutOfStock,
			"productColor": basketConfirmation.productLineItems[index].productColor,
			"productType": basketConfirmation.productLineItems[index].productType,
			"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
			"productVariantID": basketConfirmation.productLineItems[index].productVariantID,
			"collectionName": basketConfirmation.productLineItems[index].collectionName
		}
	});		
}
}

//Quickview modal on click of product from immersive experience
function openPDPOverlayImmersive() {
	pushToDataLayer({
		"event": "virtualPageview",
		"websiteCountry": pageInfo.websiteCountry,
		"userId": window.User.id,
		"language": pageInfo.language,
		"pageSubCategory": "PDP Overlay",
		"pageCategory": "Explicit Experience"
		});	
}

//productInteraction dataLayer upon click of notify me button of Coming soon product
function notifyMeClick(productId) {
	pushToDataLayer({
		"event": "productInteraction",
		"productName": getProductName(),
		"pageCategory": pageInfo.pageCategory,
		"productId": productId,
		"interactionType" : "notify_product_availability"
	});
};

function addToCartGymShark($recommendationsItems){
	pushToDataLayer({
				"currencyCode": currencyCode,
				"event": "addToCart",
				"addToCartType": "Add to Bag - Gymshark - Minicart",
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory,
				'products': crosssellProducts($recommendationsItems, "Gymshark", "Minicart")
			});
}

function minicartCrossSellafterInit($recommendations) {
	// Prevent duplicate firing
	const isTracked = sessionStorage.getItem('minicartCrossSellTracked');
	if(isTracked == 'true') return;
	
	sessionStorage.setItem('minicartCrossSellTracked','true');
	pushToDataLayer({
		"currencyCode": currencyCode,
		"eeAction": "eeListView",
		"event": "eeListView",
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		"products": crosssellProducts($recommendations.find('.slick-slide'), "Einstein", "Minicart")
	});

	$recommendations.off('click.minicartListClick')
        .on('click.minicartListClick', ".pdp-link, .thumb-link", function () {
		pushToDataLayer({
			"event": "eeListClick",
			"eeAction": "eeListClick",
			"currencyCode": currencyCode,
			"pageCategory": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"products": crosssellProducts($(this).closest('.slick-slide'), "Einstein", "Minicart")
		});
	});
}

function minicartCrossSellAddToCart($container, e) {
	e.stopPropagation();
	pushToDataLayer({
		"currencyCode": currencyCode,
		"pageSubCategory": pageInfo.pageSubCategory,
		"event": "addToCart",
		"addToCartType": "Add to Bag - Einstein - Minicart",
		"pageCategory": pageInfo.pageCategory,
		'products': crosssellProducts($container)
	});
}


function cartCrossSellafterInit($recommendations) {
	pushToDataLayer({
		"currencyCode": currencyCode,
		"eeAction": "eeListView",
		"event": "eeListView",
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		"products": crosssellProducts($recommendations.find('.slick-slide'), "Einstein", "Cart Page")
	});
}

function cartCrossSellAddToCart($container, e) {
	e.stopPropagation();
	pushToDataLayer({
		"currencyCode": currencyCode,
		"pageSubCategory": pageInfo.pageSubCategory,
		"event": "addToCart",
		"addToCartType": "Add to Bag - Einstein - Cart Page",
		"pageCategory": pageInfo.pageCategory,
		'products': crosssellProducts($container)
	});
}

function addToBagPLPCrosssell($container, elem) {
	elem.stopPropagation();
	pushToDataLayer({
		"currencyCode": currencyCode,
		"event": "addToCart",
		"addToCartType": "Add to Bag - Einstein - Product List Page",
		"pageSubCategory": pageInfo.pageSubCategory,
		"pageCategory": pageInfo.pageCategory,
		'products': crosssellProducts($container)
	});
}

// add product ai dialog PDP
function addProductAIDialogPDP(dialogVariantColor, dialogVariantSize) {
	const addToCartType = "Dialog - Product Page";
	let selectedColor, selectedSize;
	dialogVariantColor == undefined ? selectedColor = sessionStorage.getItem('selectedVariantsColor') : selectedColor = dialogVariantColor;
	dialogVariantSize == undefined ? selectedSize = sessionStorage.getItem('selectedVariantSize') : selectedSize = dialogVariantSize;
	pushToDataLayer({
		"currencyCode": window.Resources.CURRENCY,
		"event": "addToCart",
		"addToCartType": addToCartType,
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		'products': [{
			"id": pdpdata.masterID,
			"listType": pageInfo.pageCategory,
			"listName": $(".breadcrumb").find(".breadcrumb-element:eq(1)").first().text().trim(),
			"category": window.productCache.catid,
			"price": pdpdata.pricing ? pdpdata.pricing.sale ? pdpdata.pricing.sale : pdpdata.pricing.minprice ? pdpdata.pricing.minprice : null : null,
			"name": getProductName(),
			"brand": getProductBrand(),
			"quantity": Number($(".quantity select").val()),
			"size":  selectedSize ? selectedSize : pdpdata.size,
			"subCategory": window.productCache.subcategory,
			"subSubCategory": window.productCache.subsubcategory,
			"productAutoReplen": $(".add-to-cart").data("replenishable"),
			"productOutOfStock": $(".add-to-cart").data("instock"),
			"productColor": selectedColor ? selectedColor : pdpdata.productColor,
			"productType": "Product",
			"productVariantID": pdpdata.master ? pdpdata.defalutvariant : pdpdata.ID,
			"collectionName": pdpdata.customBrand,
			"productOrderType": getProductOrederType()
		}]
	});
}

// add product ai dialog PLP/HP
function addProductAIDialog(productId, quantity, variantId) {
    const addToCartType = $('.product-listing').length > 0 
        ? "Dialog - Product List Page" 
        : "Dialog - Product Page";

    const minicartData = miniBasketConfirmation.productLineItems || [];

    // Find matching product
    const matchedProduct = minicartData.find(item => 
        item.id == productId || item.productVariantID == variantId
    );

    // Use matched product if found, else fallback
    const product = matchedProduct || {};

    pushToDataLayer({
        "currencyCode": window.Resources.CURRENCY,
        "event": "addToCart",
        "addToCartType": addToCartType,
        "pageCategory": pageInfo.pageCategory,
        "pageSubCategory": pageInfo.pageSubCategory,
        'products': [{
            "id": product.id || productId,
            "listType": pageInfo.pageCategory,
            "listName": $(".breadcrumb")
                .find(".breadcrumb-element:eq(1)")
                .first()
                .text()
                .trim(),
            "category": product.category || window.productCache.catid,
            "price": product.price,
            "name": product.name || getProductName(),
            "brand": product.brand || getProductBrand(),
            "quantity": quantity,
            "size": product.size || "",
            "subCategory": product.subCategory ?? window.productCache.subcategory ?? "",
            "subSubCategory": product.subSubCategory ?? window.productCache.subsubcategory ?? "",
            "productAutoReplen": product.productAutoReplen || $(".add-to-cart").data("replenishable"),
            "productOutOfStock": product.productOutOfStock || $(".add-to-cart").data("instock"),
            "productColor": product.color || "",
            "productType": product.productType || "Product",
            "productVariantID": product.productVariantID || variantId,
            "collectionName": product.collectionName || "",
            "productOrderType": getProductOrederType()
        }]
    });
}

// add product ai dialog
function trackCartAddition(productId, quantity, currency, price, variantId) {

    // Check if pdpdata exists and has variant info
    const isPDPVariant = typeof pdpdata !== "undefined" && pdpdata && pdpdata.variant;

    const selectedVariantID = isPDPVariant ? variantId : productId;

    let dataObject = {
        productId: selectedVariantID,
        quantity: quantity,
        price: price,
        currency: currency,
        variantId: selectedVariantID
    };

    // Safe localStorage handling
    let storedProductIds;
    try {
        storedProductIds = JSON.parse(localStorage.getItem('storedproductid')) || [];
    } catch (e) {
        storedProductIds = [];
    }

    if (!storedProductIds.includes(selectedVariantID)) {
        storedProductIds.push(selectedVariantID);
        localStorage.setItem('storedproductid', JSON.stringify(storedProductIds));
    }

    return dataObject;
}

//pdp ai dialog send message
function sendAIDialogMessage() {
	pushToDataLayer({
		"event": "dialog_send_message"
	});
}

export default {
	init: function () {
		initializeGlobalEvents();
	},
	tagmanager: {
		click: function (data) {
			return trackConsultationEvent(data);
		},

		pageview: function (data) {
			return trackConsultationPageview(data);
		}
	},
	gtmInternalPromotion: {
		click: function (data) {
			return trackInternalPromotionEvent(data);
		},

		pageview: function (data) {
			return trackInternalPromotionPageView(data);
		}
	},
	populateSearchSuggestion: function() {
		populateSearchSuggestion();
	},
	reinsuranceElements: reinsuranceElements,
	narsProStepOne: narsProStepOne,
	googleAddressTracking: googleAddressTracking,
	socialLoginEvent: socialLoginEvent,
	cartModalOpen: cartModalOpen,
	cartModalClose: cartModalClose,
	minicartProductList : minicartProductList,
	searchOverlayShow : searchOverlayShow,
	searchProductTile : searchProductTile,
	searchCategoryLink : searchCategoryLink,
	searchEinstienProductList: searchEinstienProductList,
	paypalExpressSubmitEvent:paypalExpressSubmitEvent,
	removeProductFromCart : removeProductFromCart,
	couponCodeEvent : couponCodeEvent,
	payPalDataLayerPush : payPalDataLayerPush,
	payPalCartDataLayerPush : payPalCartDataLayerPush,
	appleCartDataLayerPush : appleCartDataLayerPush,
	addSelectedSamplesToCart: addSelectedSamplesToCart,
	addBonusProductMinicartDataLayer : addBonusProductMinicartDataLayer,
	addBonusProductDataLayer : addBonusProductDataLayer,
	openPDPOverlayImmersive: openPDPOverlayImmersive,
	addToCartDataLayerPush:addToCartDataLayerPush,
	googlePayDataLayerPush: googlePayDataLayerPush,
	googlePayTracking: googlePayTracking,
	paypalExpressDatalayer: paypalExpressDatalayer,
	notifyMeClick: notifyMeClick,
	minicartCrossSellafterInit: minicartCrossSellafterInit,
	minicartCrossSellAddToCart: minicartCrossSellAddToCart,
	cartCrossSellafterInit: cartCrossSellafterInit,
	cartCrossSellAddToCart: cartCrossSellAddToCart,
	minicrosssellPDPonInit: minicrosssellPDPonInit,
	minicrosssellPDPafterInit: minicrosssellPDPafterInit,
	gymSharkCrossSellafterInit: gymSharkCrossSellafterInit,
	addToCartGymShark: addToCartGymShark,
	addToBagPLPCrosssell: addToBagPLPCrosssell,
	reassuranceCheckoutDatalayer: reassuranceCheckoutDatalayer,
	trackSignInDrawerOpen: trackSignInDrawerOpen,
	trackClickCtaAccountModal : trackClickCtaAccountModal,
	trackClickCtaPerksAccountModal :trackClickCtaPerksAccountModal,
	menuCrossSellClick : menuCrossSellClick,
	menuCrosssellList : menuCrosssellList,
	addProductAIDialogPDP: addProductAIDialogPDP,
	addProductAIDialog: addProductAIDialog,
	sendAIDialogMessage: sendAIDialogMessage,
	trackCartAddition: trackCartAddition,
}